import { useState, useEffect } from "react";

const GLOBAL_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@300;400;500;600;700;900&family=Barlow:ital,wght@0,300;0,400;0,500;1,300&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; }
  body { overflow-x: hidden; }
  ::-webkit-scrollbar { width: 3px; }
  ::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 2px; }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button { opacity: .3; }
  input[type=range] { -webkit-appearance: none; flex: 1; height: 3px; background: #dde3ee; outline: none; border-radius: 2px; }
  input[type=range]::-webkit-slider-thumb { -webkit-appearance: none; width: 14px; height: 14px; border-radius: 50%; background: linear-gradient(135deg,#e8000d,#9333ea); cursor: pointer; }
  @keyframes fadeUp { from { opacity:0; transform:translateY(12px); } to { opacity:1; transform:translateY(0); } }
  .fu { animation: fadeUp .3s ease forwards; }
  table { width: 100%; border-collapse: collapse; }
  th { background:#0f172a; color:#fff; font-family:'Barlow Condensed',sans-serif; font-size:10px; letter-spacing:3px; font-weight:700; padding:10px 12px; text-align:left; }
  td { padding:10px 12px; border-bottom:1px solid #f1f5f9; font-family:'Barlow',sans-serif; font-size:13px; color:#334155; background:#fff; }
  tr:nth-child(even) td { background:#fdf4ff; }
  @keyframes greenGlow {
    0%,100% { box-shadow: 0 0 8px rgba(34,197,94,0.45), 0 0 20px rgba(34,197,94,0.2); }
    50%      { box-shadow: 0 0 16px rgba(34,197,94,0.7), 0 0 36px rgba(34,197,94,0.35), 0 0 60px rgba(34,197,94,0.12); }
  }
  @keyframes blueGlow {
    0%,100% { box-shadow: 0 0 8px rgba(59,130,246,0.45), 0 0 20px rgba(59,130,246,0.2); }
    50%      { box-shadow: 0 0 16px rgba(59,130,246,0.7), 0 0 36px rgba(59,130,246,0.35), 0 0 60px rgba(59,130,246,0.12); }
  }
  .green-glow { animation: greenGlow 6s ease-in-out infinite; }
  .blue-glow  { animation: blueGlow 6s ease-in-out infinite; }
`;

const GRAD = "linear-gradient(135deg,#e8000d,#3b82f6)";

function BonkProofLogo({ size = "md", onClick }) {
  const sizes = {
    sm: { font:15, letter:3, bolt:20, gap:8  },
    md: { font:20, letter:4, bolt:28, gap:10 },
    lg: { font:36, letter:6, bolt:48, gap:14 },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div onClick={onClick} style={{ display:"inline-flex", alignItems:"center", gap:s.gap, cursor: onClick ? "pointer" : "default" }}>
      <style>{`
        @keyframes bpGlow {
          0%   { filter: drop-shadow(0 0 4px #e8000d) drop-shadow(0 0 10px rgba(232,0,13,0.5)); }
          50%  { filter: drop-shadow(0 0 6px #3b82f6) drop-shadow(0 0 14px rgba(59,130,246,0.55)); }
          100% { filter: drop-shadow(0 0 4px #e8000d) drop-shadow(0 0 10px rgba(232,0,13,0.5)); }
        }
        @keyframes bpFloat {
          0%,100% { transform: rotate(-10deg) translateY(0px); }
          50%      { transform: rotate(-10deg) translateY(-2px); }
        }
        .bp-bolt {
          animation: bpGlow 6s ease-in-out infinite, bpFloat 6s ease-in-out infinite;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
        .bp-word {
          background: linear-gradient(135deg, #e8000d, #3b82f6);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      `}</style>

      <span className="bp-bolt">
        <svg width={s.bolt} height={s.bolt} viewBox="0 0 24 24" fill="none">
          <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" fill="#e8000d"/>
        </svg>
      </span>

      <div>
        <span className="bp-word" style={{
          fontFamily:"'Barlow Condensed',sans-serif",
          fontWeight:900,
          fontSize:s.font,
          letterSpacing:s.letter,
          display:"block",
          lineHeight:1.1,
        }}>BONKPROOF</span>
        {size !== "sm" && (
          <span style={{
            display:"block",
            fontFamily:"'Barlow Condensed',sans-serif",
            fontSize: size === "lg" ? 10 : 8,
            letterSpacing: size === "lg" ? 4 : 3,
            fontWeight:700,
            color:"rgba(59,130,246,0.55)",
            lineHeight:1,
            marginTop:1,
          }}>CYCLING NUTRITION</span>
        )}
      </div>
    </div>
  );
}


function Btn({ children, onClick, variant = "primary", style = {} }) {
  const base = { fontFamily:"'Barlow Condensed',sans-serif", fontSize:12, letterSpacing:3, fontWeight:700, padding:"11px 24px", cursor:"pointer", border:"none", transition:"all .2s" };
  const variants = { primary:{ background:GRAD, color:"#fff" }, ghost:{ background:"transparent", color:"#0f172a", border:"1.5px solid #dde3ee" }, white:{ background:"#fff", color:"#0f172a" } };
  return <button onClick={onClick} style={{ ...base, ...variants[variant], ...style }}>{children}</button>;
}

function Callout({ children, color = "#e8000d" }) {
  return <div style={{ borderLeft:`4px solid ${color}`, background:`${color}0a`, padding:"14px 18px", margin:"20px 0", fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#334155", lineHeight:1.75 }}>{children}</div>;
}

function SectionLabel({ children }) {
  return <div style={{ fontSize:12, letterSpacing:5, color:"#e8000d", fontWeight:700, marginBottom:12 }}>{children}</div>;
}

function Tag({ label, color }) {
  return <span style={{ display:"inline-block", padding:"2px 8px", fontSize:8, letterSpacing:3, fontWeight:700, border:`1px solid ${color}44`, color, background:`${color}10` }}>{label}</span>;
}

// ── NAV ─────────────────────────────────────────────────────────────────────
function Nav({ page, setPage, user, onAuthClick, onLogout }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [avatarOpen, setAvatarOpen] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);
  const initials = user ? (user.name||user.email||"?").split(" ").map(w=>w[0]).join("").toUpperCase().slice(0,2) : "";

  return (
    <nav style={{
      position:"sticky", top:0, zIndex:200,
      background: scrolled || page !== "landing" ? "rgba(236,238,245,0.95)" : "rgba(236,238,245,0.8)",
      backdropFilter:"blur(16px)", WebkitBackdropFilter:"blur(16px)",
      borderBottom:"1px solid rgba(0,0,0,0.06)",
      transition:"all .2s",
    }}>
      <div style={{ width:"100%", maxWidth:1400, margin:"0 auto", padding:"0 48px", height:54, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
        <div onClick={() => setPage("landing")} style={{ cursor:"pointer", flexShrink:0 }}>
          <BonkProofLogo size="sm" />
        </div>

        <div style={{ display:"flex", gap:2, alignItems:"center" }}>
          {[["System","science"],["Calculator","calculator"],["Products","calculator"]].map(([l,p]) => (
            <button key={l} onClick={() => setPage(p)} style={{ background:"transparent", border:"none", fontFamily:"'Barlow',sans-serif", fontSize:14, fontWeight:400, padding:"5px 14px", cursor:"pointer", color:"#64748b", borderRadius:6, transition:"color .15s" }}
              onMouseEnter={e=>e.target.style.color="#0f172a"} onMouseLeave={e=>e.target.style.color="#64748b"}>{l}</button>
          ))}
        </div>

        <div style={{ display:"flex", gap:8, alignItems:"center" }}>
          {user ? (
            <div style={{ position:"relative" }}>
              <div onClick={() => setAvatarOpen(o=>!o)} style={{ width:30, height:30, borderRadius:"50%", background:GRAD, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:11, color:"#fff", cursor:"pointer" }}>{initials}</div>
              {avatarOpen && (
                <div style={{ position:"absolute", top:38, right:0, background:"#fff", border:"1px solid rgba(0,0,0,0.08)", boxShadow:"0 8px 32px rgba(0,0,0,0.12)", minWidth:190, borderRadius:12, overflow:"hidden", zIndex:300 }}>
                  <div style={{ padding:"12px 16px", borderBottom:"1px solid rgba(0,0,0,0.06)" }}>
                    <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:14 }}>{user.name||"Athlete"}</div>
                    <div style={{ fontSize:11, color:"#94a3b8", marginTop:2 }}>{user.email}</div>
                  </div>
                  {[["My Profile","profile"],["Calculator","calculator"],["My Plans","profiles"]].map(([l,p])=>(
                    <button key={p} onClick={()=>{ setPage(p); setAvatarOpen(false); }} style={{ width:"100%", background:"none", border:"none", padding:"9px 16px", textAlign:"left", fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#334155", cursor:"pointer", display:"block" }}>{l}</button>
                  ))}
                  <div style={{ borderTop:"1px solid rgba(0,0,0,0.06)" }}>
                    <button onClick={()=>{ onLogout(); setAvatarOpen(false); }} style={{ width:"100%", background:"none", border:"none", padding:"9px 16px", textAlign:"left", fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#e8000d", cursor:"pointer" }}>Sign out</button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <button onClick={onAuthClick} style={{ background:"none", border:"none", fontFamily:"'Barlow',sans-serif", fontSize:14, color:"#64748b", cursor:"pointer", padding:"5px 10px" }}>Sign in</button>
          )}
          <button onClick={() => setPage("calculator")} style={{ display:"flex", alignItems:"center", gap:6, background:"#0f172a", color:"#fff", border:"none", cursor:"pointer", fontFamily:"'Barlow',sans-serif", fontSize:13, fontWeight:500, padding:"8px 16px", borderRadius:8, transition:"background .2s" }}
            onMouseEnter={e=>e.currentTarget.style.background="#1e293b"} onMouseLeave={e=>e.currentTarget.style.background="#0f172a"}>
            Build my plan <span style={{fontSize:15}}>→</span>
          </button>
          <button onClick={() => setMenuOpen(o=>!o)} style={{ background:"none", border:"1px solid rgba(0,0,0,0.1)", borderRadius:6, width:30, height:30, cursor:"pointer", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:4 }}>
            {[0,1,2].map(i => <span key={i} style={{ width:11, height:1.5, background:"#64748b", display:"block" }}/>)}
          </button>
        </div>
      </div>
      {menuOpen && (
        <div style={{ background:"#fff", borderTop:"1px solid rgba(0,0,0,0.06)", padding:"8px 32px 16px" }}>
          {[["Calculator","calculator"],["My Plans","profiles"],["Science","science"]].map(([l,p]) => (
            <button key={p} onClick={() => { setPage(p); setMenuOpen(false); }} style={{ display:"block", width:"100%", background:"none", border:"none", fontFamily:"'Barlow',sans-serif", fontSize:15, padding:"10px 0", cursor:"pointer", color:"#334155", textAlign:"left", borderBottom:"1px solid rgba(0,0,0,0.04)" }}>{l}</button>
          ))}
          {user
            ? <button onClick={()=>{ onLogout(); setMenuOpen(false); }} style={{ background:"none", border:"none", color:"#e8000d", fontFamily:"'Barlow',sans-serif", fontSize:14, padding:"10px 0", cursor:"pointer", display:"block" }}>Sign out</button>
            : <button onClick={()=>{ onAuthClick(); setMenuOpen(false); }} style={{ marginTop:8, background:"#0f172a", border:"none", color:"#fff", fontFamily:"'Barlow',sans-serif", fontSize:14, fontWeight:500, padding:"11px", cursor:"pointer", borderRadius:8, width:"100%" }}>Sign in / Create account</button>
          }
        </div>
      )}
    </nav>
  );
}

// ── LANDING ──────────────────────────────────────────────────────────────────
function Landing({ setPage }) {
  const [activeZone, setActiveZone] = useState("z4");

  const ZONES = [
    { key:"z2", label:"Z2", full:"Endurance", carbs:52, fluid:1.6, sodium:380, color:"#22c55e", status:"fueled" },
    { key:"z3", label:"Z3", full:"Tempo",     carbs:68, fluid:2.2, sodium:580, color:"#22c55e", status:"fueled" },
    { key:"z4", label:"Z4", full:"Threshold", carbs:86, fluid:3.0, sodium:790, color:"#3b82f6", status:"fueled" },
    { key:"z5", label:"Z5", full:"Race",      carbs:104, fluid:3.4, sodium:940, color:"#e8000d", status:"fueled" },
  ];
  const Z = ZONES.find(z=>z.key===activeZone);

  const S = { fontFamily:"'Barlow',sans-serif" };
  const SC = { fontFamily:"'Barlow Condensed',sans-serif" };

  const BG = "#e8eaf2";
  const CARD = "#ffffff";
  const DARK = "#0f172a";

  return (
    <div style={{ background:BG, ...S }}>

      {/* ════════════════════════════════════════════════════════
          HERO
      ════════════════════════════════════════════════════════ */}
      <div style={{ background:"linear-gradient(145deg,#dde1ef 0%,#e4e7f4 40%,#dde6f0 100%)", minHeight:"calc(100vh - 54px)", display:"flex", alignItems:"center" }}>
        <div style={{ width:"100%", maxWidth:1400, margin:"0 auto", padding:"0 64px", display:"grid", gridTemplateColumns:"1fr 1.1fr", gap:80, alignItems:"center" }}>

          {/* ── Left copy ── */}
          <div>
            {/* Badge */}
            <div style={{ display:"inline-flex", alignItems:"center", gap:10, background:"rgba(255,255,255,0.65)", border:"1px solid rgba(0,0,0,0.07)", borderRadius:32, padding:"7px 16px 7px 8px", marginBottom:32 }}>
              <BonkProofLogo size="sm" />
              <span style={{ ...SC, fontSize:11, fontWeight:700, letterSpacing:2.5, color:"#475569" }}>PRECISION FUEL STUDIO</span>
            </div>

            {/* Headline */}
            <h1 style={{ ...SC, fontWeight:900, fontSize:"clamp(52px,6.5vw,96px)", lineHeight:0.9, letterSpacing:-2, color:DARK, marginBottom:24 }}>
              Fueling for<br/>riders who<br/>
              <span style={{ background:"linear-gradient(135deg,#e8000d,#3b82f6)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>expect more.</span>
            </h1>

            <p style={{ fontSize:17, color:"#475569", lineHeight:1.65, maxWidth:440, marginBottom:36 }}>
              A precision fueling cockpit for riders who want pro-level carb, fluid and sodium targets — without the spreadsheet energy.
            </p>

            {/* CTAs */}
            <div style={{ display:"flex", gap:10, marginBottom:40, flexWrap:"wrap" }}>
              <button onClick={() => setPage("calculator")} style={{ ...S, display:"flex", alignItems:"center", gap:10, background:DARK, color:"#fff", border:"none", cursor:"pointer", fontSize:16, fontWeight:500, padding:"15px 30px", borderRadius:10, transition:"all .2s" }}
                onMouseEnter={e=>{e.currentTarget.style.background="#1e293b";e.currentTarget.style.transform="translateY(-1px)";}}
                onMouseLeave={e=>{e.currentTarget.style.background=DARK;e.currentTarget.style.transform="translateY(0)";}}>
                Start the calculator <span style={{fontSize:17}}>→</span>
              </button>
              <button onClick={() => setPage("science")} style={{ ...S, display:"flex", alignItems:"center", gap:8, background:"rgba(255,255,255,0.7)", color:DARK, border:"1px solid rgba(0,0,0,0.1)", cursor:"pointer", fontSize:16, fontWeight:500, padding:"15px 26px", borderRadius:10, transition:"background .2s" }}
                onMouseEnter={e=>e.currentTarget.style.background="#fff"} onMouseLeave={e=>e.currentTarget.style.background="rgba(255,255,255,0.7)"}>
                See race protocol
              </button>
            </div>

            {/* Stats row */}
            <div style={{ display:"flex", gap:0, paddingTop:28, borderTop:"1px solid rgba(0,0,0,0.08)", marginTop:8 }}>
              {[["120g","Elite carb ceiling"],["30s","Plan build time"],["3","Premium brands"]].map(([n,l],i) => (
                <div key={l} style={{ paddingRight:32, marginRight:32, borderRight: i<2 ? "1px solid rgba(0,0,0,0.08)" : "none" }}>
                  <div style={{ ...SC, fontWeight:900, fontSize:32, color:DARK, lineHeight:1 }}>{n}</div>
                  <div style={{ fontSize:13, color:"#94a3b8", marginTop:5 }}>{l}</div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Right: App mockup ── */}
          <div style={{ position:"relative" }}>
            {/* Drop shadow layer */}
            <div style={{ position:"absolute", inset:"-12px", background:"rgba(0,0,0,0.12)", borderRadius:28, filter:"blur(32px)", transform:"translateY(8px)" }}/>

            <div style={{ position:"relative", background:"#1a1f2e", borderRadius:20, overflow:"hidden", boxShadow:"0 24px 64px rgba(0,0,0,0.22), 0 0 0 1px rgba(255,255,255,0.07)" }}>
              {/* App header */}
              <div style={{ padding:"18px 20px 10px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                <div>
                  <div style={{ fontSize:9, letterSpacing:3, color:"rgba(255,255,255,0.35)", fontWeight:700, marginBottom:2, ...SC }}>TODAY'S PLAN</div>
                  <div style={{ ...SC, fontSize:26, fontWeight:900, color:"#fff", letterSpacing:0.5 }}>{Z.label} {Z.full} · 2h</div>
                </div>
                <div style={{ width:34, height:34, borderRadius:9, background:"rgba(255,255,255,0.07)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:16 }}>🚴</div>
              </div>

              {/* Zone tabs */}
              <div style={{ display:"flex", gap:5, padding:"6px 20px 14px" }}>
                {ZONES.map(z => (
                  <button key={z.key} onClick={() => setActiveZone(z.key)} style={{ flex:1, padding:"7px 2px", borderRadius:7, border:"none", cursor:"pointer", fontSize:11, fontWeight:700, ...SC, letterSpacing:1, transition:"all .2s",
                    background: activeZone===z.key ? z.key==="z2"||z.key==="z3" ? "#22c55e" : z.key==="z4" ? "#3b82f6" : "#e8000d" : "rgba(255,255,255,0.06)",
                    color: activeZone===z.key ? "#fff" : "rgba(255,255,255,0.35)",
                  }}>{z.label}</button>
                ))}
              </div>

              {/* Big metric cards */}
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, padding:"0 20px 16px" }}>
                <div style={{ background:"rgba(255,255,255,0.06)", borderRadius:14, padding:"20px 22px" }}>
                  <div style={{ fontSize:11, color:"rgba(255,255,255,0.4)", marginBottom:8, letterSpacing:1 }}>Carbs</div>
                  <div style={{ ...SC, fontWeight:900, fontSize:64, color:"#fff", lineHeight:1 }}>{Z.carbs}</div>
                  <div style={{ fontSize:11, color:"rgba(255,255,255,0.35)", marginTop:3 }}>g/hr</div>
                </div>
                <div style={{ borderRadius:14, padding:"20px 22px", background: Z.key==="z2"||Z.key==="z3" ? "#16a34a" : Z.key==="z4" ? "#3b82f6" : "#e8000d", transition:"background .3s" }}>
                  <div style={{ fontSize:11, color:"rgba(255,255,255,0.7)", marginBottom:8, letterSpacing:1 }}>Total</div>
                  <div style={{ ...SC, fontWeight:900, fontSize:64, color:"#fff", lineHeight:1 }}>{Z.carbs*2}</div>
                  <div style={{ fontSize:11, color:"rgba(255,255,255,0.7)", marginTop:3 }}>grams</div>
                </div>
              </div>

              {/* Fueling status indicator */}
              <div style={{ margin:"0 20px 14px", padding:"9px 14px", borderRadius:9, display:"flex", alignItems:"center", gap:8,
                background: Z.key==="z2"||Z.key==="z3" ? "rgba(34,197,94,0.12)" : "rgba(59,130,246,0.08)",
                border: `1px solid ${Z.key==="z2"||Z.key==="z3" ? "rgba(34,197,94,0.25)" : "rgba(59,130,246,0.25)"}`,
                boxShadow: Z.key==="z2"||Z.key==="z3" ? "0 0 14px rgba(34,197,94,0.4), 0 0 28px rgba(34,197,94,0.2), inset 0 0 8px rgba(34,197,94,0.08)" : "none",
                transition:"all .3s",
              }}>
                <div style={{ width:7, height:7, borderRadius:"50%", background: Z.key==="z2"||Z.key==="z3" ? "#16a34a" : Z.key==="z4" ? "#3b82f6" : "#e8000d", flexShrink:0 }}/>
                <span style={{ fontSize:12, fontWeight:600, color: Z.key==="z2"||Z.key==="z3" ? "#16a34a" : Z.key==="z4" ? "#3b82f6" : "#e8000d" }}>
                  {Z.key==="z2"||Z.key==="z3" ? "Fueling on target — glycogen preserved" : Z.key==="z4" ? "High demand — execute every 30 min" : "Race intensity — no missed doses"}
                </span>
              </div>

              {/* Schedule bars */}
              <div style={{ background:"rgba(0,0,0,0.2)", padding:"14px 20px 18px" }}>
                <div style={{ display:"flex", justifyContent:"space-between", marginBottom:12 }}>
                  <span style={{ fontSize:11, color:"rgba(255,255,255,0.45)", fontWeight:600 }}>Execution schedule</span>
                  <span style={{ fontSize:10, color:"rgba(255,255,255,0.25)" }}>Every 30 minutes</span>
                </div>
                {["0.5h","1h","1.5h","2h"].map((label, i) => (
                  <div key={label} style={{ display:"flex", alignItems:"center", gap:10, marginBottom:i<3?7:0 }}>
                    <span style={{ fontSize:10, color:"rgba(255,255,255,0.3)", minWidth:26, ...SC }}>{label}</span>
                    <div style={{ flex:1, height:3, background:"rgba(255,255,255,0.07)", borderRadius:2, overflow:"hidden" }}>
                      <div style={{ width:`${[55,70,85,100][i]}%`, height:"100%", borderRadius:2, transition:"width .4s ease",
                        background: i===3 ? (Z.key==="z2"||Z.key==="z3" ? "#16a34a" : Z.key==="z4" ? "#3b82f6" : "#e8000d") : "rgba(255,255,255,0.22)"
                      }}/>
                    </div>
                    <span style={{ fontSize:10, color:"rgba(255,255,255,0.3)", minWidth:28, textAlign:"right", ...SC }}>{Math.round(Z.carbs/2)}g</span>
                  </div>
                ))}
              </div>

              {/* Fluid + sodium */}
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:1, background:"rgba(255,255,255,0.04)" }}>
                {[["FLUID",Z.fluid+"L"],["SODIUM",Z.sodium+"mg"]].map(([l,v]) => (
                  <div key={l} style={{ padding:"18px 24px", background:"rgba(0,0,0,0.18)" }}>
                    <div style={{ fontSize:9, color:"rgba(255,255,255,0.35)", letterSpacing:2, marginBottom:5, ...SC }}>{l}</div>
                    <div style={{ ...SC, fontSize:28, fontWeight:900, color:"#fff" }}>{v}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Floating badge */}
            <div style={{ position:"absolute", bottom:-12, right:16, background:"#fff", borderRadius:10, padding:"9px 14px", boxShadow:"0 6px 24px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)", display:"flex", alignItems:"center", gap:8 }}>
              <div style={{ width:7, height:7, borderRadius:"50%", background:"#22c55e" }}/>
              <span style={{ fontSize:12, fontWeight:600, color:DARK }}>Plan calculated</span>
              <span style={{ fontSize:11, color:"#94a3b8" }}>3 brands compared</span>
            </div>
          </div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════
          BRAND STRIP
      ════════════════════════════════════════════════════════ */}
      <div style={{ background:"rgba(0,0,0,0.04)", borderTop:"1px solid rgba(0,0,0,0.06)", borderBottom:"1px solid rgba(0,0,0,0.06)", padding:"14px 32px" }}>
        <div style={{ width:"100%", maxWidth:1400, margin:"0 auto", padding:"0 48px", display:"flex", alignItems:"center", justifyContent:"center", gap:36, flexWrap:"wrap" }}>
          <div style={{ fontSize:10, color:"#94a3b8", letterSpacing:2.5, fontWeight:700, ...SC }}>COMPARES PRODUCTS FROM</div>
          {[["SiS","Beta Fuel"],["PF&H","Precision Fuel"],["Maurten","Hydrogel"],["DIY","40p/ride"]].map(([b,s]) => (
            <div key={b} style={{ display:"flex", alignItems:"center", gap:6 }}>
              <span style={{ ...SC, fontWeight:900, fontSize:16, color:DARK }}>{b}</span>
              <span style={{ fontSize:11, color:"#94a3b8" }}>{s}</span>
            </div>
          ))}
          <div style={{ display:"flex", alignItems:"center", gap:6, padding:"4px 12px", background:"rgba(59,130,246,0.08)", borderRadius:20, border:"1px solid rgba(59,130,246,0.25)" }}>
            <div style={{ width:5, height:5, borderRadius:"50%", background:"#16a34a" }}/>
            <span style={{ fontSize:10, fontWeight:700, color:"#3b82f6", ...SC, letterSpacing:1 }}>INDEPENDENT — NO BRAND BIAS</span>
          </div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════
          RED VS GREEN — THE FUELING STATE SECTION
      ════════════════════════════════════════════════════════ */}
      <div style={{ width:"100%", maxWidth:1400, margin:"0 auto", padding:"72px 64px" }}>
        <div style={{ textAlign:"center", marginBottom:40 }}>
          <div style={{ ...SC, fontSize:11, letterSpacing:4, color:"#e8000d", fontWeight:700, marginBottom:10 }}>THE DIFFERENCE</div>
          <h2 style={{ ...SC, fontWeight:900, fontSize:"clamp(30px,4vw,48px)", color:DARK, lineHeight:1, letterSpacing:-0.5 }}>Two states. One choice.</h2>
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
          {/* RED — deficit */}
          <div style={{ background:"#fff", borderRadius:16, border:"1px solid rgba(0,0,0,0.07)", overflow:"hidden" }}>
            <div style={{ background:"linear-gradient(135deg,#7f1d1d,#991b1b)", padding:"20px 24px", display:"flex", alignItems:"center", gap:12 }}>
              <div style={{ width:10, height:10, borderRadius:"50%", background:"#e8000d", boxShadow:"0 0 8px #e8000d" }}/>
              <span style={{ ...SC, fontWeight:900, fontSize:16, color:"#fff", letterSpacing:1 }}>UNDER-FUELED</span>
            </div>
            <div style={{ padding:"24px" }}>
              {[
                ["Hour 1","Feeling fine. Glycogen reserves burning.","#dc2626"],
                ["Hour 2","Power fading. Legs going heavy.","#dc2626"],
                ["Hour 3","The wall. Pace collapses. Brain fog.","#7f1d1d"],
              ].map(([t,d,c]) => (
                <div key={t} style={{ display:"flex", gap:14, marginBottom:16, alignItems:"flex-start" }}>
                  <div style={{ ...SC, fontWeight:900, fontSize:12, color:c, minWidth:48, marginTop:2 }}>{t}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ height:3, background:c, borderRadius:2, marginBottom:6, width: t==="Hour 1"?"80%":t==="Hour 2"?"40%":"10%" }}/>
                    <div style={{ fontSize:12, color:"#64748b", lineHeight:1.5 }}>{d}</div>
                  </div>
                </div>
              ))}
              <div style={{ marginTop:8, padding:"10px 14px", background:"rgba(220,38,38,0.06)", border:"1px solid rgba(220,38,38,0.15)", borderRadius:8, fontSize:12, color:"#dc2626", fontWeight:600 }}>
                ⚠ Bonk. Ride over. Recovery compromised.
              </div>
            </div>
          </div>

          {/* GREEN — fueled */}
          <div style={{ background:"#fff", borderRadius:16, border:"1px solid rgba(0,0,0,0.07)", overflow:"hidden" }}>
            <div style={{ background:"linear-gradient(135deg,#14532d,#166534)", padding:"20px 24px", display:"flex", alignItems:"center", gap:12 }}>
              <div style={{ width:10, height:10, borderRadius:"50%", background:"#22c55e", boxShadow:"0 0 10px #22c55e, 0 0 20px rgba(34,197,94,0.4)" }}/>
              <span style={{ ...SC, fontWeight:900, fontSize:16, color:"#fff", letterSpacing:1 }}>BONKPROOF</span>
            </div>
            <div style={{ padding:"24px" }}>
              {[
                ["Hour 1","88g carbs in. Glucose and fructose absorbed.","#22c55e"],
                ["Hour 2","Power sustained. Glycogen topped up.","#22c55e"],
                ["Hour 3","Strong finish. Kick for the line.","#14532d"],
              ].map(([t,d,c]) => (
                <div key={t} style={{ display:"flex", gap:14, marginBottom:16, alignItems:"flex-start" }}>
                  <div style={{ ...SC, fontWeight:900, fontSize:12, color:c, minWidth:48, marginTop:2 }}>{t}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ height:3, background:c, borderRadius:2, marginBottom:6, width:"100%" }}/>
                    <div style={{ fontSize:12, color:"#64748b", lineHeight:1.5 }}>{d}</div>
                  </div>
                </div>
              ))}
              <div style={{ marginTop:8, padding:"10px 14px", background:"rgba(34,197,94,0.08)", border:"1px solid rgba(34,197,94,0.25)", borderRadius:8, fontSize:12, color:"#16a34a", fontWeight:600 }}>
                ✓ Finish strong. Recover faster. Come back better.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════
          HOW IT WORKS — tight 4-column grid
      ════════════════════════════════════════════════════════ */}
      <div style={{ background:"rgba(0,0,0,0.03)", borderTop:"1px solid rgba(0,0,0,0.06)", borderBottom:"1px solid rgba(0,0,0,0.06)", padding:"56px 64px" }}>
        <div style={{ width:"100%" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-end", marginBottom:36, flexWrap:"wrap", gap:16 }}>
            <div>
              <div style={{ ...SC, fontSize:11, letterSpacing:4, color:"#e8000d", fontWeight:700, marginBottom:8 }}>HOW IT WORKS</div>
              <h2 style={{ ...SC, fontWeight:900, fontSize:"clamp(28px,3.5vw,44px)", color:DARK, lineHeight:1, letterSpacing:-0.5 }}>Four steps. Under 60 seconds.</h2>
            </div>
            <button onClick={() => setPage("calculator")} style={{ ...S, background:DARK, color:"#fff", border:"none", cursor:"pointer", fontSize:13, fontWeight:500, padding:"10px 20px", borderRadius:8 }}>Try it now →</button>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:12 }}>
            {[
              { num:"01", icon:"⚖️", title:"Enter your data", body:"Weight, sex, intensity zone and duration. 20 seconds." },
              { num:"02", icon:"🌡️", title:"Set conditions", body:"Temperature and altitude adjust every target automatically." },
              { num:"03", icon:"🔬", title:"Get your plan", body:"Exact carb, fluid and sodium totals with product counts." },
              { num:"04", icon:"💾", title:"Save and rate", body:"Save plans. Rate gut feel. Every ride makes the next one better." },
            ].map((s,i) => (
              <div key={i} style={{ background:CARD, borderRadius:14, padding:"24px 20px", border:"1px solid rgba(0,0,0,0.07)", position:"relative", overflow:"hidden" }}>
                <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background: i===0||i===1 ? "#22c55e" : i===2 ? "#3b82f6" : GRAD }}/>
                <div style={{ ...SC, fontSize:52, fontWeight:900, color:"rgba(0,0,0,0.04)", lineHeight:1, position:"absolute", top:8, right:12 }}>{s.num}</div>
                <div style={{ fontSize:22, marginBottom:14 }}>{s.icon}</div>
                <div style={{ ...SC, fontWeight:700, fontSize:16, color:DARK, marginBottom:8 }}>{s.title}</div>
                <div style={{ fontSize:13, color:"#64748b", lineHeight:1.6 }}>{s.body}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════
          SCIENCE — dark strip
      ════════════════════════════════════════════════════════ */}
      <div style={{ background:DARK, padding:"72px 64px" }}>
        <div style={{ width:"100%", maxWidth:1400, margin:"0 auto", display:"grid", gridTemplateColumns:"1fr 1fr", gap:64, alignItems:"center" }}>
          <div>
            <div style={{ ...SC, fontSize:11, letterSpacing:4, color:"#60a5fa", fontWeight:700, marginBottom:14 }}>PEER-REVIEWED SCIENCE</div>
            <h2 style={{ ...SC, fontWeight:900, fontSize:"clamp(28px,3.5vw,44px)", color:"#fff", lineHeight:1, letterSpacing:-0.5, marginBottom:18 }}>Not branded.<br/>Not guesswork.</h2>
            <p style={{ fontSize:14, color:"rgba(255,255,255,0.45)", lineHeight:1.7, marginBottom:28, maxWidth:360 }}>
              Every calculation references published research. The same science elite teams pay consultants for — free, for everyone.
            </p>
            <button onClick={() => setPage("science")} style={{ ...S, background:"rgba(255,255,255,0.07)", color:"rgba(255,255,255,0.7)", border:"1px solid rgba(255,255,255,0.1)", cursor:"pointer", fontSize:13, fontWeight:500, padding:"10px 20px", borderRadius:8, transition:"all .2s" }}
              onMouseEnter={e=>{e.currentTarget.style.background="rgba(255,255,255,0.12)";e.currentTarget.style.color="#fff";}}
              onMouseLeave={e=>{e.currentTarget.style.background="rgba(255,255,255,0.07)";e.currentTarget.style.color="rgba(255,255,255,0.7)";}}>
              Read the science library →
            </button>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
            {[
              { num:"1:0.8", lbl:"Malto:Fructose", desc:"Dual transporter protocol — maximises absorption above 90g/hr." },
              { num:"Ijaz '24", lbl:"Body mass", desc:"Weight-scaled carb targets from peer-reviewed research." },
              { num:"+50%", lbl:"Heat fluid", desc:"Fluid scales up to 50% in extreme heat automatically." },
              { num:"94%", lbl:"Female factor", desc:"Devries 2006 — sex-specific substrate targets." },
            ].map(c => (
              <div key={c.num} style={{ background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:12, padding:"20px 16px" }}>
                <div style={{ ...SC, fontWeight:900, fontSize:26, background:"linear-gradient(135deg,#e8000d,#3b82f6)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", lineHeight:1, marginBottom:2 }}>{c.num}</div>
                <div style={{ fontSize:9, letterSpacing:2, color:"rgba(255,255,255,0.28)", ...SC, fontWeight:700, marginBottom:8 }}>{c.lbl.toUpperCase()}</div>
                <div style={{ fontSize:12, color:"rgba(255,255,255,0.38)", lineHeight:1.5 }}>{c.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════
          PRODUCT COMPARISON
      ════════════════════════════════════════════════════════ */}
      <div style={{ width:"100%", maxWidth:1400, margin:"0 auto", padding:"72px 64px" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-end", marginBottom:32, flexWrap:"wrap", gap:16 }}>
          <div>
            <div style={{ ...SC, fontSize:11, letterSpacing:4, color:"#e8000d", fontWeight:700, marginBottom:8 }}>PRODUCT ENGINE</div>
            <h2 style={{ ...SC, fontWeight:900, fontSize:"clamp(28px,3.5vw,44px)", color:DARK, lineHeight:1, letterSpacing:-0.5 }}>Exact counts. Zero guesswork.</h2>
          </div>
          <div style={{ fontSize:13, color:"#64748b", maxWidth:280, lineHeight:1.6 }}>BonkProof tells you exactly how many units of each product to take — calculated from your weight, zone and conditions.</div>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr) 1fr", gap:10 }}>
          {[
            { brand:"SIS", full:"Science in Sport", product:"Beta Fuel Gel", carbs:40, sodium:55, highlight:false },
            { brand:"PF&H", full:"Precision Fuel & Hydration", product:"PF30 Gel", carbs:30, sodium:1500, highlight:true },
            { brand:"MAURTEN", full:"Maurten", product:"Gel 100", carbs:25, sodium:0, highlight:false },
          ].map(p => (
            <div key={p.brand} style={{ background:CARD, borderRadius:14, padding:"22px", border: p.highlight ? "2px solid #e8000d" : "1px solid rgba(0,0,0,0.07)", position:"relative" }}>
              {p.highlight && <div style={{ position:"absolute", top:-10, left:"50%", transform:"translateX(-50%)", background:"#e8000d", color:"#fff", fontSize:8, letterSpacing:2, fontWeight:700, padding:"3px 10px", borderRadius:20, ...SC, whiteSpace:"nowrap" }}>RECOMMENDED</div>}
              <div style={{ fontSize:9, color:"#94a3b8", letterSpacing:2, marginBottom:3, ...SC, fontWeight:700 }}>{p.full.toUpperCase()}</div>
              <div style={{ ...SC, fontWeight:900, fontSize:18, color:DARK, marginBottom:16 }}>{p.product}</div>
              {[["Carbs",p.carbs+"g"],["Sodium",p.sodium>0?p.sodium+"mg":"—"]].map(([l,v]) => (
                <div key={l} style={{ display:"flex", justifyContent:"space-between", padding:"6px 0", borderBottom:"1px solid rgba(0,0,0,0.05)", fontSize:12 }}>
                  <span style={{ color:"#94a3b8" }}>{l}</span>
                  <span style={{ ...SC, fontWeight:700, fontSize:14 }}>{v}</span>
                </div>
              ))}
              <button onClick={() => setPage("calculator")} style={{ ...S, width:"100%", marginTop:14, background: p.highlight ? DARK : "transparent", color: p.highlight ? "#fff" : DARK, border: p.highlight ? "none" : "1px solid rgba(0,0,0,0.1)", borderRadius:7, padding:"10px", fontSize:12, fontWeight:600, cursor:"pointer" }}>
                Get my count →
              </button>
            </div>
          ))}

          {/* DIY vertical card */}
          <div style={{ background:"#f0fdf4", borderRadius:14, padding:"22px", border:"1px solid rgba(34,197,94,0.25)", display:"flex", flexDirection:"column", justifyContent:"space-between" }}>
            <div>
              <div style={{ fontSize:9, color:"#16a34a", letterSpacing:2, marginBottom:4, ...SC, fontWeight:700 }}>FREE ALTERNATIVE</div>
              <div style={{ ...SC, fontWeight:900, fontSize:18, color:"#16a34a", marginBottom:10 }}>DIY Mix</div>
              <div style={{ fontSize:12, color:"#16a34a", lineHeight:1.6, marginBottom:16 }}>Maltodextrin + fructose at 1:0.8. Same dual-transporter formula. <strong>40p a ride.</strong></div>
              {[["Cost/ride","~40p"],["vs branded","~£4+"]].map(([l,v]) => (
                <div key={l} style={{ display:"flex", justifyContent:"space-between", padding:"5px 0", borderBottom:"1px solid rgba(22,163,74,0.12)", fontSize:11 }}>
                  <span style={{ color:"#16a34a" }}>{l}</span>
                  <span style={{ ...SC, fontWeight:700, fontSize:13, color:"#16a34a" }}>{v}</span>
                </div>
              ))}
            </div>
            <button onClick={() => setPage("science")} style={{ ...S, marginTop:14, background:"#16a34a", color:"#fff", border:"none", borderRadius:7, padding:"10px", fontSize:12, fontWeight:600, cursor:"pointer" }}>
              See recipe →
            </button>
          </div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════
          TESTIMONIALS
      ════════════════════════════════════════════════════════ */}
      <div style={{ background:"rgba(0,0,0,0.03)", borderTop:"1px solid rgba(0,0,0,0.06)", padding:"64px 64px" }}>
        <div style={{ width:"100%" }}>
          <div style={{ ...SC, fontSize:11, letterSpacing:4, color:"#e8000d", fontWeight:700, marginBottom:28, textAlign:"center" }}>WHAT RIDERS SAY</div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:12 }}>
            {[
              { q:"Finally a fueling tool that doesn't cap at 90g/hr. As someone who's trained their gut to handle 130g, this is the first calculator that actually makes sense.", n:"James R.", r:"Cat 2 road racer" },
              { q:"I used to guess my bottle and gel count the night before. Now I know exactly what I need and why. The product breakdown is brilliant.", n:"Sarah M.", r:"Amateur cyclist" },
              { q:"The heat and altitude adjustments sold it. Racing in Mallorca in July is completely different to a winter ride and now my plan reflects that.", n:"Tom K.", r:"Triathlete" },
            ].map(t => (
              <div key={t.n} style={{ background:CARD, borderRadius:14, padding:"22px", border:"1px solid rgba(0,0,0,0.06)" }}>
                <div style={{ width:24, height:3, background:"linear-gradient(135deg,#e8000d,#3b82f6)", borderRadius:2, marginBottom:14 }}/>
                <p style={{ fontSize:13, lineHeight:1.7, color:"#475569", marginBottom:16 }}>"{t.q}"</p>
                <div style={{ ...SC, fontWeight:700, fontSize:14, color:DARK }}>{t.n}</div>
                <div style={{ fontSize:11, color:"#94a3b8", marginTop:2 }}>{t.r}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════
          FINAL CTA
      ════════════════════════════════════════════════════════ */}
      <div style={{ background:"linear-gradient(145deg,#dde1ef 0%,#e4e7f4 50%,#dde6f0 100%)", padding:"96px 64px" }}>
        <div style={{ maxWidth:600, margin:"0 auto", textAlign:"center" }}>
          <h2 style={{ ...SC, fontWeight:900, fontSize:"clamp(36px,5vw,64px)", color:DARK, lineHeight:0.93, letterSpacing:-1, marginBottom:20 }}>
            The wall is optional.<br/>
            <span style={{ background:"linear-gradient(135deg,#e8000d,#3b82f6)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>BonkProof isn't.</span>
          </h2>
          <p style={{ fontSize:15, color:"#64748b", marginBottom:32, lineHeight:1.65 }}>Free. Peer-reviewed science. No account needed to try it.</p>
          <button onClick={() => setPage("calculator")} style={{ ...S, display:"inline-flex", alignItems:"center", gap:10, background:DARK, color:"#fff", border:"none", cursor:"pointer", fontSize:15, fontWeight:500, padding:"14px 32px", borderRadius:10, transition:"all .2s" }}
            onMouseEnter={e=>{e.currentTarget.style.background="#1e293b";e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow="0 12px 36px rgba(0,0,0,0.15)";}}
            onMouseLeave={e=>{e.currentTarget.style.background=DARK;e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";}}>
            Start for free <span style={{fontSize:19}}>→</span>
          </button>
          <div style={{ marginTop:16, fontSize:11, color:"#94a3b8", letterSpacing:1 }}>PEER-REVIEWED SCIENCE · FREE · NO CARD NEEDED</div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════════════
          FOOTER
      ════════════════════════════════════════════════════════ */}
      <div style={{ background:DARK, padding:"28px 64px" }}>
        <div style={{ width:"100%", maxWidth:1400, margin:"0 auto", display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:14 }}>
          <div><BonkProofLogo size="sm" /></div>
          <div style={{ display:"flex", gap:20 }}>
            {["Science","Privacy","Terms","Contact"].map(l => <span key={l} style={{ fontSize:12, color:"rgba(255,255,255,0.3)", cursor:"pointer" }}>{l}</span>)}
          </div>
          <div style={{ fontSize:11, color:"rgba(255,255,255,0.2)" }}>© 2026 BonkProof Ltd</div>
        </div>
        <div style={{ width:"100%", maxWidth:1400, margin:"14px auto 0", paddingTop:14, borderTop:"1px solid rgba(255,255,255,0.05)", fontSize:11, color:"rgba(255,255,255,0.18)", lineHeight:1.6 }}>
          <span style={{ color:"#e8000d" }}>⚠ </span>BonkProof estimates are based on sports science guidelines — not personalised medical advice. Always practise fueling strategies in training first.
        </div>
      </div>
    </div>
  );
}

// ── CALCULATION ENGINE ───────────────────────────────────────────────────────
const INTENSITY = {
  z1: { label:"Active Recovery", zone:"Z1", sub:"Below aerobic threshold", baseCarbHr:20, fluidPerKg:5,  sodiumPerKg:4.5,  desc:"Fat is almost your entire fuel source here. Carbs are optional under 90 minutes — focus on hydration and enjoying the ride." },
  z2: { label:"Endurance",       zone:"Z2", sub:"Aerobic base / long rides", baseCarbHr:55, fluidPerKg:7,  sodiumPerKg:6.5,  desc:"The bread and butter of cycling. Fat still dominates but carbs become important past 90 minutes. Steady, consistent intake beats big boluses." },
  z3: { label:"Tempo",           zone:"Z3", sub:"Comfortably hard / sustained", baseCarbHr:60, fluidPerKg:9,  sodiumPerKg:8.0,  desc:"Mixed substrate territory. Carb demand rises sharply. This is where under-fueling starts to cost you — don't wait until you feel it." },
  z4: { label:"Threshold",       zone:"Z4", sub:"FTP and above", baseCarbHr:75, fluidPerKg:11, sodiumPerKg:10.0, desc:"Gut motility drops at threshold intensity. Liquid carbs over solids. Precision matters more here than at any other zone." },
  z5: { label:"Race Effort",     zone:"Z5", sub:"All-out / max exertion", baseCarbHr:90, fluidPerKg:12, sodiumPerKg:11.5, desc:"Full performance mode. Every gram counts. Your gut training ceiling is the only limit — push it if you've earned it." },
};
const GUT_CEILING = { beginner:60, trained:90, elite:120 };
const GUT_MULTIPLIER = {
  beginner: { z1:1.0, z2:1.0, z3:1.0, z4:1.0, z5:1.0 },
  trained:  { z1:1.0, z2:1.0, z3:1.0, z4:1.0, z5:1.0 },
  elite:    { z1:1.0, z2:1.1, z3:1.15, z4:1.2, z5:1.3 },
};
const GUT = {
  beginner: { label:"Beginner",      sub:"Untrained gut, <60g/hr",            max:60  },
  trained:  { label:"Trained",       sub:"6+ months high-carb fueling",        max:90  },
  elite:    { label:"Elite Trained", sub:"Systematically trained 100–120g/hr", max:120 },
};
const DURATION_FLOOR = {
  z1: (d) => { if(d<1)return 0; if(d<2)return 0;  return 20; },
  z2: (d) => { if(d<1)return 0; if(d<2)return 20; if(d<3)return 40; return 45; },
  z3: (d) => { if(d<1)return 0; if(d<2)return 30; if(d<2.5)return 50; return 60; },
  z4: (d) => { if(d<1)return 0; if(d<2)return 30; if(d<2.5)return 60; if(d<3)return 75; return 80; },
  z5: (d) => { if(d<1)return 0; if(d<2)return 30; if(d<2.5)return 60; if(d<3)return 75; return 90; },
};
function massCorrFactor(w) { return Math.max(0.75, Math.min(1.25, 0.6 + w/175)); }
function sexCarbFactor(s) { return s === "female" ? 0.94 : 1.0; }
function calcNutrition(weightKg, intensity, gut, durationH, heatAdj, altAdj, lutealPhase, sex) {
  const prof = INTENSITY[intensity];
  const ceiling = GUT_CEILING[gut];
  const gutMult = GUT_MULTIPLIER[gut][intensity];
  const intensityScaled = prof.baseCarbHr * gutMult;
  const durationFloor = DURATION_FLOOR[intensity](durationH);
  let cph = Math.max(intensityScaled, durationFloor);
  cph *= massCorrFactor(weightKg);
  cph *= sexCarbFactor(sex);
  cph = cph * altAdj * heatAdj.cm;
  if (lutealPhase) cph *= 1.08;
  cph = Math.min(Math.round(cph), ceiling);
  const totalC = Math.round(cph * durationH);
  let fluidMult = heatAdj.fm;
  if (lutealPhase) fluidMult *= 1.05;
  const totalF = Math.round(prof.fluidPerKg * weightKg * durationH * fluidMult / 100) * 100;
  const totalS = Math.round(prof.sodiumPerKg * weightKg * durationH * heatAdj.sm / 50) * 50;
  return { cph, totalC, totalF, totalS };
}
const PRODUCTS = {
  sis: { brand:"Science in Sport", short:"SiS", items:[
    { name:"Beta Fuel Drink Mix", type:"drink", carbsPer:80, sodiumPer:180, unit:"sachet", note:"2:1 maltodextrin:fructose optimised" },
    { name:"Beta Fuel Gel", type:"gel", carbsPer:40, sodiumPer:55, unit:"gel", note:"Dual-source, isotonic" },
    { name:"Beta Fuel Chew", type:"solid", carbsPer:30, sodiumPer:30, unit:"pack", note:"For lower-intensity sections" },
    { name:"Hydro Electrolyte", type:"elec", carbsPer:4, sodiumPer:360, unit:"tablet", note:"Additional sodium top-up" },
  ]},
  precision: { brand:"Precision Fuel & Hydration", short:"PF&H", items:[
    { name:"PF 90 Drink Mix", type:"drink", carbsPer:90, sodiumPer:130, unit:"sachet", note:"High-carb dual-source formula" },
    { name:"PF 30 Gel", type:"gel", carbsPer:30, sodiumPer:30, unit:"gel", note:"Compact, easy on the stomach" },
    { name:"PF 30 Chew", type:"solid", carbsPer:30, sodiumPer:30, unit:"pack", note:"Solid fuel option" },
    { name:"PH 1500 Tablet", type:"elec", carbsPer:2, sodiumPer:1500, unit:"tablet", note:"High-sodium hydration only" },
  ]},
  maurten: { brand:"Maurten", short:"Maurten", items:[
    { name:"Drink Mix 320", type:"drink", carbsPer:80, sodiumPer:110, unit:"sachet", note:"Hydrogel tech, 2:1 ratio" },
    { name:"Gel 100", type:"gel", carbsPer:25, sodiumPer:0, unit:"gel", note:"Pure hydrogel, no additives" },
    { name:"Gel 100 CAF", type:"gel", carbsPer:25, sodiumPer:0, unit:"gel", note:"100mg caffeine — use sparingly" },
    { name:"Drink Mix 160", type:"elec", carbsPer:40, sodiumPer:55, unit:"sachet", note:"Lighter option for easy sections" },
  ]},
};

// Homemade mix recipe — scaled to total carb target
function HomemadeTab({ totalC, totalS, totalF, durationH }) {
  // 1:0.8 malto:fructose ratio — optimal dual-transporter formula
  const malto  = Math.round(totalC * (1 / 1.8));
  const fructo = Math.round(totalC * (0.8 / 1.8));
  const sodiumG = (totalS / 1000).toFixed(1);
  const mlPerHr = Math.round(totalF / durationH);
  const bottleCount = Math.ceil(totalF / 750);

  const row = (label, value, note) => (
    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"12px 0", borderBottom:"1px solid #f8fafc" }}>
      <div>
        <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:16 }}>{label}</div>
        {note && <div style={{ fontSize:10, color:"#94a3b8", marginTop:2, fontFamily:"'Barlow',sans-serif" }}>{note}</div>}
      </div>
      <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:28, background:GRAD, WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", textAlign:"right" }}>{value}</div>
    </div>
  );

  return (
    <div style={{ padding:"18px" }}>
      {/* Header */}
      <div style={{ background:"#0f172a", padding:"16px 18px", marginBottom:18, position:"relative", overflow:"hidden" }}>
        <div style={{ position:"absolute", width:200, height:200, borderRadius:"50%", background:"#9333ea", filter:"blur(60px)", opacity:.15, top:-80, right:-60, pointerEvents:"none" }}/>
        <div style={{ position:"relative", zIndex:2 }}>
          <div style={{ fontSize:8, letterSpacing:5, color:"#e8000d", fontWeight:700, marginBottom:4 }}>🧪 DIY MIX</div>
          <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:22, color:"#fff", lineHeight:1, marginBottom:6 }}>MAKE YOUR OWN FUEL</div>
          <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:12, color:"rgba(255,255,255,.5)", lineHeight:1.65, fontWeight:300 }}>
            Maltodextrin + fructose at 1:0.8 — the same dual-transporter formula behind every premium product, at a fraction of the cost. Scaled to your exact carb target.
          </div>
        </div>
      </div>

      {/* Ingredients */}
      <div style={{ fontSize:8, letterSpacing:5, color:"#94a3b8", fontWeight:700, marginBottom:4 }}>INGREDIENTS FOR THIS RIDE</div>
      {row("Maltodextrin",    `${malto}g`,    "DE17–19, food-grade powder — neutral taste")}
      {row("Fructose",        `${fructo}g`,   "Pure crystalline fructose — not HFCS")}
      {row("Sodium (salt)",   `${sodiumG}g`,  "Fine table salt or sodium citrate")}
      {row("Water",           `${totalF}ml`,  `~${mlPerHr}ml/hr across ${bottleCount} × ${bottleCount===1?"750ml bottle":"750ml bottles"}`)}

      {/* Method */}
      <div style={{ background:"#fef2f8", border:"1px solid #fca5a544", padding:"16px", marginTop:16 }}>
        <div style={{ fontSize:8, letterSpacing:5, color:"#e8000d", fontWeight:700, marginBottom:10 }}>METHOD</div>
        {[
          "Weigh maltodextrin and fructose separately — don't eyeball it.",
          "Mix powders together dry, then divide evenly across your bottles.",
          "Add water and shake hard. Maltodextrin takes longer to dissolve than it looks.",
          "Add salt and shake again. Taste — it should be very mildly sweet, barely salty.",
          "Keep refrigerated until use. Consume within 6 hours of mixing.",
        ].map((s,i) => (
          <div key={i} style={{ display:"flex", gap:10, marginBottom:9, alignItems:"flex-start" }}>
            <div style={{ width:20, height:20, borderRadius:"50%", background:GRAD, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:11, color:"#fff", marginTop:1 }}>{i+1}</div>
            <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#334155", lineHeight:1.65 }}>{s}</div>
          </div>
        ))}
      </div>

      {/* Cost note */}
      <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", padding:"12px 14px", marginTop:10, display:"flex", gap:10, alignItems:"flex-start" }}>
        <span style={{ fontSize:16, flexShrink:0 }}>💰</span>
        <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:12, color:"#15803d", lineHeight:1.65 }}>
          Maltodextrin costs ~£4/kg and fructose ~£5/kg in bulk. A full day's fueling at {totalC}g carbs costs approximately <strong>£{((malto/1000)*4 + (fructo/1000)*5).toFixed(2)}</strong> — vs £15–25 for branded equivalents.
        </div>
      </div>

      {/* Warning */}
      <div style={{ background:"#fff7ed", border:"1px solid #fed7aa", padding:"12px 14px", marginTop:10, display:"flex", gap:10, alignItems:"flex-start" }}>
        <span style={{ fontSize:16, flexShrink:0 }}>⚠️</span>
        <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:12, color:"#c2410c", lineHeight:1.65 }}>
          Always practise this mix in training before race day. Source food-grade maltodextrin (not industrial). Start at lower concentrations if you're new to high-carb fueling.
        </div>
      </div>

      {/* Where to buy */}
      <div style={{ marginTop:16 }}>
        <div style={{ fontSize:8, letterSpacing:5, color:"#94a3b8", fontWeight:700, marginBottom:8 }}>WHERE TO BUY</div>
        <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
          {[
            { name:"Bulk (bulkpowders.co.uk)", note:"Maltodextrin & fructose, UK delivery" },
            { name:"MyProtein (myprotein.com)",   note:"Maltodextrin widely available" },
            { name:"Amazon",                      note:"Search 'food grade maltodextrin DE17'" },
          ].map((s,i) => (
            <div key={i} style={{ background:"#fff", border:"1px solid #dde3ee", padding:"10px 14px", display:"flex", gap:10 }}>
              <div style={{ width:6, height:6, borderRadius:"50%", background:GRAD, flexShrink:0, marginTop:5 }}/>
              <div>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:14 }}>{s.name}</div>
                <div style={{ fontSize:10, color:"#94a3b8", marginTop:2 }}>{s.note}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
function getRatio(cph) {
  if (cph <= 60) return { ratio:"Glucose only", note:"Single-transporter range — no fructose needed" };
  if (cph <= 90) return { ratio:"2 : 1", note:"Maltodextrin to Fructose — standard dual-transporter protocol" };
  return { ratio:"1 : 0.8", note:"Maltodextrin:Fructose — dual-transporter maximised above 90g/hr" };
}
function getHeatAdj(t) {
  if (t <= 15) return { fm:1.0, sm:1.0, cm:1.0, label:null };
  if (t <= 25) return { fm:1.15, sm:1.2, cm:1.0, label:"WARM" };
  if (t <= 32) return { fm:1.3, sm:1.4, cm:0.95, label:"HOT" };
  return { fm:1.5, sm:1.6, cm:0.9, label:"EXTREME HEAT" };
}
function getAltAdj(a) {
  if (a < 1000) return { cm:1.0, label:null };
  if (a < 2000) return { cm:1.05, label:"MODERATE ALTITUDE" };
  if (a < 3000) return { cm:1.1, label:"HIGH ALTITUDE" };
  return { cm:1.15, label:"VERY HIGH ALTITUDE" };
}
function calcProducts(key, totalCarbs, totalSodium) {
  const p = PRODUCTS[key];
  const drink = p.items.find(i=>i.type==="drink");
  const gel = p.items.find(i=>i.type==="gel");
  const solid = p.items.find(i=>i.type==="solid");
  const elec = p.items.find(i=>i.type==="elec");
  let drinkN = Math.max(1, Math.round(totalCarbs*0.55/drink.carbsPer));
  let remaining = totalCarbs - drinkN*drink.carbsPer;
  let gelN = gel && remaining > 0 ? Math.max(0, Math.round(remaining*0.65/gel.carbsPer)) : 0;
  remaining -= gelN*(gel?.carbsPer||0);
  let solidN = solid && remaining > (gel?.carbsPer||0)*0.6 ? Math.max(0, Math.round(remaining/solid.carbsPer)) : 0;
  remaining -= solidN*(solid?.carbsPer||0);
  if (gel && remaining >= (gel.carbsPer||0)*0.5) gelN += 1;
  const coveredNa = drinkN*drink.sodiumPer + gelN*(gel?.sodiumPer||0) + solidN*(solid?.sodiumPer||0);
  const elecN = elec && (totalSodium-coveredNa)>200 ? Math.min(6, Math.max(0, Math.round((totalSodium-coveredNa)/elec.sodiumPer))) : 0;
  return [
    { ...drink, count:drinkN, totalCarbs:drinkN*drink.carbsPer, totalNa:drinkN*drink.sodiumPer },
    ...(gelN>0?[{ ...gel, count:gelN, totalCarbs:gelN*gel.carbsPer, totalNa:gelN*gel.sodiumPer }]:[]),
    ...(solidN>0?[{ ...solid, count:solidN, totalCarbs:solidN*solid.carbsPer, totalNa:solidN*solid.sodiumPer }]:[]),
    ...(elecN>0&&elec?[{ ...elec, count:elecN, totalCarbs:elecN*elec.carbsPer, totalNa:elecN*elec.sodiumPer }]:[]),
  ];
}
const INT_COLORS = { z1:"#22c55e", z2:"#84cc16", z3:"#eab308", z4:"#3b82f6", z5:"#e8000d" };
const TYPE_COLORS = { drink:"#e8000d", gel:"#e8000d", solid:"#3b82f6", elec:"#8b5cf6" };

// ── CALCULATOR ───────────────────────────────────────────────────────────────
function Calculator({ user, setPage, savePlan, logEvent }) {
  const [weight,      setWeight]      = useState(user?String(user.weight||80):"80");
  const [unit,        setUnit]        = useState(user?(user.unit||"kg"):"kg");
  const [hours,       setHours]       = useState("3");
  const [mins,        setMins]        = useState("0");
  const [intensity,   setIntensity]   = useState("z4");
  const [gut,         setGut]         = useState(user?(user.gut||"trained"):"trained");
  const [temp,        setTemp]        = useState(20);
  const [altitude,    setAltitude]    = useState(0);
  const [lutealPhase, setLutealPhase] = useState(false);
  const [sex,         setSex]         = useState(user?(user.sex||"male"):"male");
  const [tab,         setTab]         = useState("sis");
  const [results,     setResults]     = useState(null);
  const [screen,      setScreen]      = useState("inputs");
  const [saveState,   setSaveState]   = useState("idle"); // idle | naming | saving | saved | error
  const [planName,    setPlanName]    = useState("");
  const [rideDate,    setRideDate]    = useState("");

  const weightNum = parseFloat(weight)||0;
  const weightKg  = unit==="kg"?weightNum:Math.round(weightNum*0.453592);
  const hoursNum  = parseFloat(hours)||0;
  const minsNum   = parseFloat(mins)||0;
  const durationH = Math.max(0.1, hoursNum+minsNum/60);

  const generate = () => {
    setScreen("loading");
    setSaveState("idle");
    setTimeout(() => {
      const heat = getHeatAdj(temp);
      const alt  = getAltAdj(altitude);
      const { cph, totalC, totalF, totalS } = calcNutrition(weightKg, intensity, gut, durationH, heat, alt.cm, lutealPhase, sex);
      const ratio = getRatio(cph);
      const prods = {};
      Object.keys(PRODUCTS).forEach(k => { prods[k] = calcProducts(k, totalC, totalS); });
      setResults({ cph, totalC, totalF, totalS, ratio, prods, heatLabel:heat.label, altLabel:alt.label });
      setScreen("results");
    }, 1800);
  };

  const handleSavePlan = async () => {
    if (!results) return;
    setSaveState("saving");
    const defaultName = `${INTENSITY[intensity].zone} ${INTENSITY[intensity].label} · ${hoursNum}h${minsNum>0?` ${minsNum}m`:""} · ${new Date().toLocaleDateString("en-GB",{day:"numeric",month:"short"})}`;
    const name = planName.trim() || defaultName;
    const result = await savePlan({
      name,
      zone:        intensity,
      durationH,
      weightKg,
      gut,
      temp,
      altitude,
      sex,
      lutealPhase,
      totalC:      results.totalC,
      cph:         results.cph,
      totalF:      results.totalF,
      totalS:      results.totalS,
      ratio:       results.ratio.ratio,
      brand:       tab,
      rideDate:    rideDate || null,
    });
    console.log("Save result:", result);
    if (result?.ok) {
      setSaveState("saved");
      setPlanName("");
      setRideDate("");
    } else {
      console.error("Save failed:", result?.error);
      setSaveState("error");
    }
  };

  const inp = { background:"#fff", border:"1px solid #dde3ee", outline:"none", fontFamily:"'Barlow Condensed',sans-serif", fontWeight:800, color:"#0f172a" };

  // ── LOADING SCREEN ─────────────────────────────────────────────────────────
  if (screen === "loading") return (
    <div style={{ minHeight:"calc(100vh - 58px)", background:"#0f172a", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:32 }}>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes pulse { 0%,100%{opacity:.3} 50%{opacity:1} }
        @keyframes bar { 0%{width:0%} 100%{width:100%} }
        .loading-bar { animation: bar 1.6s cubic-bezier(.4,0,.2,1) forwards; }
        .loading-dot { animation: pulse 1.2s ease-in-out infinite; }
        .loading-dot:nth-child(2) { animation-delay:.2s; }
        .loading-dot:nth-child(3) { animation-delay:.4s; }
      `}</style>
      <BonkProofLogo size="md"/>
      <div style={{ textAlign:"center" }}>
        <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:"clamp(28px,5vw,44px)", color:"#fff", letterSpacing:1, marginBottom:8 }}>
          CALCULATING YOUR PLAN
        </div>
        <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, color:"rgba(255,255,255,.4)", fontWeight:300 }}>
          Applying sports science to your inputs
        </div>
      </div>
      {/* Progress bar */}
      <div style={{ width:280, height:3, background:"rgba(255,255,255,.1)", borderRadius:2, overflow:"hidden" }}>
        <div className="loading-bar" style={{ height:"100%", background:GRAD, borderRadius:2 }}/>
      </div>
      {/* Animated steps */}
      <div style={{ display:"flex", flexDirection:"column", gap:10, width:280 }}>
        {[
          ["Intensity × duration baseline","0s"],
          ["Body mass correction (Ijaz 2024)","0.3s"],
          ["Environmental adjustments","0.7s"],
          ["Product recommendations","1.1s"],
        ].map(([label, delay],i) => (
          <div key={i} style={{ display:"flex", alignItems:"center", gap:10, animation:`fadeUp .4s ease ${delay} both` }}>
            <div style={{ width:6, height:6, borderRadius:"50%", background:GRAD, flexShrink:0 }}/>
            <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:11, color:"rgba(255,255,255,.35)", letterSpacing:.5 }}>{label}</div>
          </div>
        ))}
      </div>
      {/* Dots */}
      <div style={{ display:"flex", gap:8 }}>
        {[0,1,2].map(i=><div key={i} className="loading-dot" style={{ width:8, height:8, borderRadius:"50%", background:"#e8000d" }}/>)}
      </div>
    </div>
  );

  // ── RESULTS SCREEN ─────────────────────────────────────────────────────────
  if (screen === "results" && results) return (
    <div style={{ background:"#f0f2f7", minHeight:"calc(100vh - 58px)" }}>
      <style>{`
        @keyframes slideUp { from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:translateY(0)} }
        .res-card { animation: slideUp .5s ease both; }
        .res-card:nth-child(1){animation-delay:.05s}
        .res-card:nth-child(2){animation-delay:.12s}
        .res-card:nth-child(3){animation-delay:.19s}
        .res-card:nth-child(4){animation-delay:.26s}
        .res-card:nth-child(5){animation-delay:.33s}
        .res-card:nth-child(6){animation-delay:.40s}
        .res-grid3{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;}
        .res-grid3b{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;}
        @media(max-width:640px){
          .res-grid3{grid-template-columns:1fr 1fr;}
          .res-grid3b{grid-template-columns:1fr 1fr;}
        }
        @media(max-width:400px){
          .res-grid3{grid-template-columns:1fr;}
          .res-grid3b{grid-template-columns:1fr;}
        }
      `}</style>

      {/* Hero strip */}
      <div style={{ background:"#0f172a", padding:"28px 20px 24px", position:"relative", overflow:"hidden" }}>
        <div style={{ position:"absolute", width:400, height:400, borderRadius:"50%", background:"#e8000d", filter:"blur(80px)", opacity:.08, top:-200, right:-100, pointerEvents:"none" }}/>
        <div style={{ maxWidth:760, margin:"0 auto", position:"relative", zIndex:2 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:12 }}>
            <div>
              <div style={{ fontSize:8, letterSpacing:5, color:"#e8000d", fontWeight:700, marginBottom:6 }}>YOUR FUELING PLAN</div>
              <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:"clamp(24px,4vw,38px)", color:"#fff", lineHeight:1 }}>
                {INTENSITY[intensity].zone} {INTENSITY[intensity].label.toUpperCase()} · {hoursNum}H{minsNum>0?` ${minsNum}M`:""} · {weightKg}KG
              </div>
              <div style={{ display:"flex", gap:6, marginTop:10, flexWrap:"wrap" }}>
                {[results.heatLabel, results.altLabel].filter(Boolean).map(l=>(
                  <span key={l} style={{ padding:"2px 10px", fontSize:8, letterSpacing:3, fontWeight:700, border:"1px solid #e8000d44", color:"#e8000d", background:"#e8000d11" }}>{l}</span>
                ))}
                <span style={{ padding:"2px 10px", fontSize:8, letterSpacing:3, fontWeight:700, border:"1px solid rgba(255,255,255,.1)", color:"rgba(255,255,255,.4)" }}>
                  {sex==="female"?(lutealPhase?"FEMALE · LUTEAL":"FEMALE"):"MALE"} · {GUT[gut].label.toUpperCase()}
                </span>
              </div>
            </div>
            <button onClick={()=>setScreen("inputs")} style={{ background:"none", border:"1px solid rgba(255,255,255,.15)", color:"rgba(255,255,255,.6)", fontFamily:"'Barlow Condensed',sans-serif", fontSize:10, letterSpacing:3, fontWeight:700, padding:"8px 16px", cursor:"pointer" }}>
              ← ADJUST INPUTS
            </button>
          </div>
        </div>
      </div>

      <div style={{ maxWidth:760, margin:"0 auto", padding:"20px 16px", display:"flex", flexDirection:"column", gap:12 }}>

        {/* Big 3 */}
        <div className="res-grid3 res-card">
          {[
            { n:results.totalC, u:"g", label:"Total Carbs", sub:"for this ride" },
            { n:results.cph,    u:"g/hr", label:"Per Hour",   sub:"target intake rate" },
            { n:(results.totalF/1000).toFixed(1), u:"L", label:"Total Fluid", sub:"hydration target" },
          ].map((s,i)=>(
            <div key={i} style={{ background:"#fff", border:"1px solid #dde3ee", padding:"20px 16px", textAlign:"center", position:"relative", overflow:"hidden" }}>
              <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:GRAD }}/>
              <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:"clamp(40px,7vw,64px)", lineHeight:1, background:GRAD, WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>{s.n}</div>
              <div style={{ fontSize:11, color:"#e8000d", fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, letterSpacing:2 }}>{s.u}</div>
              <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:14, letterSpacing:1, marginTop:6 }}>{s.label}</div>
              <div style={{ fontSize:10, color:"#94a3b8", marginTop:2, fontFamily:"'Barlow',sans-serif", fontWeight:300 }}>{s.sub}</div>
            </div>
          ))}
        </div>

        {/* Secondary 3 */}
        <div className="res-grid3b res-card">
          <div style={{ background:"#fff", border:"1px solid #dde3ee", padding:"16px" }}>
            <div style={{ fontSize:8, letterSpacing:4, color:"#94a3b8", fontWeight:700, marginBottom:8 }}>CARB RATIO</div>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:28, letterSpacing:2, background:GRAD, WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>{results.ratio.ratio}</div>
            <div style={{ fontSize:10, color:"#94a3b8", letterSpacing:.5, marginTop:6, lineHeight:1.6, fontFamily:"'Barlow',sans-serif", fontWeight:300 }}>{results.ratio.note}</div>
          </div>
          <div style={{ background:"#fff", border:"1px solid #dde3ee", padding:"16px" }}>
            <div style={{ fontSize:8, letterSpacing:4, color:"#94a3b8", fontWeight:700, marginBottom:8 }}>SODIUM</div>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:28, color:"#e8000d" }}>{results.totalS}<span style={{ fontSize:14, fontWeight:700, color:"#94a3b8", marginLeft:4 }}>mg</span></div>
            <div style={{ fontSize:10, color:"#94a3b8", marginTop:6, fontFamily:"'Barlow',sans-serif", fontWeight:300 }}>total electrolyte target</div>
          </div>
          <div style={{ background:"#fff", border:"1px solid #dde3ee", padding:"16px" }}>
            <div style={{ fontSize:8, letterSpacing:4, color:"#94a3b8", fontWeight:700, marginBottom:8 }}>PER HOUR</div>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:28, color:"#9333ea" }}>{Math.round(results.totalF/durationH)}<span style={{ fontSize:14, fontWeight:700, color:"#94a3b8", marginLeft:4 }}>ml</span></div>
            <div style={{ fontSize:10, color:"#94a3b8", marginTop:6, fontFamily:"'Barlow',sans-serif", fontWeight:300 }}>fluid per hour</div>
          </div>
        </div>

        {/* Intensity note */}
        <div className="res-card" style={{ background:"#fff", borderLeft:"3px solid #e8000d", border:"1px solid #dde3ee", borderLeftWidth:3, padding:"12px 16px", fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#475569", lineHeight:1.75, fontStyle:"italic" }}>
          {INTENSITY[intensity].desc}
        </div>

        {/* Per-hour fueling schedule */}
        {durationH >= 1 && (() => {
          // Build schedule intervals — every 30 mins
          const intervalMins = 30;
          const totalMins = Math.round(durationH * 60);
          const stops = [];
          for (let m = intervalMins; m <= totalMins; m += intervalMins) {
            stops.push(m);
          }
          // Per interval targets
          const carbsPerInterval  = Math.round(results.cph * (intervalMins / 60));
          const fluidPerInterval  = Math.round((results.totalF / durationH) * (intervalMins / 60));
          const sodiumPerInterval = Math.round((results.totalS / durationH) * (intervalMins / 60));
          // Format time
          const fmt = (mins) => {
            const h = Math.floor(mins / 60);
            const m = mins % 60;
            if (h === 0) return `${m}min`;
            if (m === 0) return `${h}h`;
            return `${h}h ${m}m`;
          };
          return (
            <div className="res-card" style={{ background:"#fff", border:"1px solid #dde3ee", overflow:"hidden" }}>
              <div style={{ padding:"14px 18px 0" }}>
                <div style={{ fontSize:8, letterSpacing:5, color:"#94a3b8", fontWeight:700, marginBottom:4 }}>PER-HOUR FUELING SCHEDULE</div>
                <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:12, color:"#94a3b8", marginBottom:14, fontWeight:300 }}>
                  Every {intervalMins} minutes · screenshot this for the ride
                </div>
              </div>
              {/* Header */}
              <div style={{ display:"grid", gridTemplateColumns:"80px 1fr 1fr 1fr", background:"#0f172a", padding:"8px 18px" }}>
                {["TIME","CARBS","FLUID","SODIUM"].map(h=>(
                  <div key={h} style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:9, letterSpacing:3, fontWeight:700, color:"rgba(255,255,255,.5)" }}>{h}</div>
                ))}
              </div>
              {/* Rows */}
              {stops.map((mins, i) => {
                const isHour = mins % 60 === 0;
                return (
                  <div key={mins} style={{ display:"grid", gridTemplateColumns:"80px 1fr 1fr 1fr", padding:"10px 18px", borderBottom:i<stops.length-1?"1px solid #f8fafc":"none", background:isHour?"#fef2f8":"#fff", alignItems:"center" }}>
                    {/* Time */}
                    <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                      {isHour && <div style={{ width:6, height:6, borderRadius:"50%", background:GRAD, flexShrink:0 }}/>}
                      <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:isHour?900:700, fontSize:isHour?16:14, color:isHour?"#e8000d":"#64748b" }}>{fmt(mins)}</div>
                    </div>
                    {/* Carbs */}
                    <div>
                      <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:18, color:isHour?"#e8000d":"#334155" }}>{carbsPerInterval}</span>
                      <span style={{ fontSize:10, color:"#94a3b8", marginLeft:3 }}>g</span>
                    </div>
                    {/* Fluid */}
                    <div>
                      <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:18, color:isHour?"#9333ea":"#334155" }}>{fluidPerInterval}</span>
                      <span style={{ fontSize:10, color:"#94a3b8", marginLeft:3 }}>ml</span>
                    </div>
                    {/* Sodium */}
                    <div>
                      <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:18, color:isHour?"#3b82f6":"#334155" }}>{sodiumPerInterval}</span>
                      <span style={{ fontSize:10, color:"#94a3b8", marginLeft:3 }}>mg</span>
                    </div>
                  </div>
                );
              })}
              {/* Totals row */}
              <div style={{ display:"grid", gridTemplateColumns:"80px 1fr 1fr 1fr", padding:"10px 18px", background:"#0f172a", alignItems:"center" }}>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:12, letterSpacing:2, color:"rgba(255,255,255,.4)" }}>TOTAL</div>
                <div>
                  <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:18, background:GRAD, WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>{results.totalC}</span>
                  <span style={{ fontSize:10, color:"rgba(255,255,255,.3)", marginLeft:3 }}>g</span>
                </div>
                <div>
                  <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:18, color:"#9333ea" }}>{results.totalF}</span>
                  <span style={{ fontSize:10, color:"rgba(255,255,255,.3)", marginLeft:3 }}>ml</span>
                </div>
                <div>
                  <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:18, color:"#3b82f6" }}>{results.totalS}</span>
                  <span style={{ fontSize:10, color:"rgba(255,255,255,.3)", marginLeft:3 }}>mg</span>
                </div>
              </div>
              <div style={{ padding:"10px 18px", background:"#f8fafc", fontFamily:"'Barlow',sans-serif", fontSize:11, color:"#94a3b8", lineHeight:1.6 }}>
                ⚡ On-hour checkpoints highlighted in red — these are your key fueling moments. Don't wait until you feel hungry or thirsty.
              </div>
            </div>
          );
        })()}

        {/* Products */}
        <div className="res-card" style={{ background:"#fff", border:"1px solid #dde3ee" }}>
          <div style={{ padding:"16px 18px 0" }}>
            <div style={{ fontSize:8, letterSpacing:5, color:"#94a3b8", fontWeight:700, marginBottom:12 }}>PRODUCT RECOMMENDATIONS</div>
            <div style={{ display:"flex", borderBottom:"1px solid #f1f5f9", marginBottom:0, overflowX:"auto" }}>
              {Object.entries(PRODUCTS).map(([k,p])=>(
                <button key={k} onClick={()=>setTab(k)} style={{ background:"transparent", border:"none", borderBottom:`2px solid ${tab===k?"#e8000d":"transparent"}`, fontFamily:"'Barlow Condensed',sans-serif", fontSize:11, letterSpacing:2, fontWeight:700, padding:"8px 14px", cursor:"pointer", color:tab===k?"#0f172a":"#94a3b8", marginBottom:-1, whiteSpace:"nowrap" }}>{p.short}</button>
              ))}
            </div>
          </div>
          <div style={{ display:"flex", flexDirection:"column", gap:1 }}>
            {results.prods[tab].map((item,i)=>{
              const tc=TYPE_COLORS[item.type]||"#64748b";
              return (
                <div key={i} style={{ borderTop:i>0?"1px solid #f8fafc":"none", padding:"14px 18px", display:"grid", gridTemplateColumns:"1fr auto", gap:16, alignItems:"center" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:12 }}>
                    <div style={{ width:36, height:36, borderRadius:"50%", background:`${tc}15`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                      <div style={{ width:10, height:10, borderRadius:"50%", background:tc }}/>
                    </div>
                    <div>
                      <div style={{ fontSize:8, letterSpacing:3, fontWeight:700, color:tc, marginBottom:3 }}>{item.type.toUpperCase()}</div>
                      <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:16 }}>{item.name}</div>
                      <div style={{ fontSize:10, color:"#94a3b8", marginTop:2, fontFamily:"'Barlow',sans-serif" }}>{item.note}</div>
                    </div>
                  </div>
                  <div style={{ textAlign:"right" }}>
                    <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:36, color:tc, lineHeight:1 }}>{item.count}</div>
                    <div style={{ fontSize:9, color:"#94a3b8", letterSpacing:2 }}>{item.unit}{item.count!==1?"s":""}</div>
                    <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:14, color:"#334155", marginTop:4 }}>{item.totalCarbs}g carbs</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* DIY Mix — clean bottle measurements only */}
        <div className="res-card" style={{ background:"#fff", border:"1px solid #e9d5ff" }}>
          <div style={{ padding:"16px 18px", display:"flex", justifyContent:"space-between", alignItems:"center", borderBottom:"1px solid #f3e8ff", flexWrap:"wrap", gap:10 }}>
            <div style={{ display:"flex", alignItems:"center", gap:10 }}>
              <span style={{ fontSize:18 }}>🧪</span>
              <div>
                <div style={{ fontSize:8, letterSpacing:5, color:"#9333ea", fontWeight:700 }}>FREE ALTERNATIVE</div>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:18, lineHeight:1 }}>MAKE YOUR OWN MIX</div>
              </div>
            </div>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:22, color:"#9333ea" }}>
              ~£{((Math.round(results.totalC*(1/1.8))/1000)*4 + (Math.round(results.totalC*(0.8/1.8))/1000)*5).toFixed(2)}
              <span style={{ fontSize:10, color:"#94a3b8", fontWeight:400, marginLeft:4 }}>est. cost</span>
            </div>
          </div>

          {/* Bottle measurements */}
          <div style={{ padding:"14px 18px" }}>
            <div style={{ fontSize:8, letterSpacing:4, color:"#94a3b8", fontWeight:700, marginBottom:10 }}>
              FOR THIS RIDE — {Math.ceil(results.totalF/750)} × 750ML BOTTLE{Math.ceil(results.totalF/750)>1?"S":""} · 1:0.8 MALTO:FRUCTOSE
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:8, marginBottom:14 }}>
              {[
                { label:"MALTODEXTRIN", value:`${Math.round(results.totalC*(1/1.8))}g`, color:"#9333ea" },
                { label:"FRUCTOSE",     value:`${Math.round(results.totalC*(0.8/1.8))}g`, color:"#e8000d" },
                { label:"SALT",         value:`${(results.totalS/1000).toFixed(1)}g`, color:"#3b82f6" },
                { label:"WATER",        value:`${results.totalF}ml`, color:"#0ea5e9" },
              ].map(i=>(
                <div key={i.label} style={{ background:"#fdf4ff", border:"1px solid #e9d5ff", padding:"10px 8px", textAlign:"center" }}>
                  <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:22, color:i.color, lineHeight:1 }}>{i.value}</div>
                  <div style={{ fontSize:7, letterSpacing:2, color:"#94a3b8", fontWeight:700, marginTop:4 }}>{i.label}</div>
                </div>
              ))}
            </div>
            <button onClick={()=>setPage("science","diy")} style={{
              width:"100%", background:"linear-gradient(135deg,#9333ea,#e8000d)", border:"none", color:"#fff",
              fontFamily:"'Barlow Condensed',sans-serif", fontSize:12, letterSpacing:4, fontWeight:700,
              padding:"11px", cursor:"pointer",
            }}>
              SEE FULL RECIPE & METHOD →
            </button>
          </div>
        </div>

        {/* Save Plan */}
        <div className="res-card" style={{ background:"#fff", border:"1px solid #dde3ee", overflow:"hidden" }}>
          {!user ? (
            // Not logged in — prompt to sign in
            <div style={{ padding:"20px", display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:12 }}>
              <div>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:18, marginBottom:4 }}>SAVE THIS PLAN</div>
                <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#64748b", fontWeight:300 }}>Sign in to save your plan and track gut feel after the ride.</div>
              </div>
              <Btn onClick={()=>setPage("auth")} style={{ fontSize:11, padding:"10px 20px", whiteSpace:"nowrap" }}>SIGN IN TO SAVE</Btn>
            </div>
          ) : saveState === "saved" ? (
            // Successfully saved
            <div style={{ padding:"20px", display:"flex", alignItems:"center", gap:14 }}>
              <div style={{ width:40, height:40, borderRadius:"50%", background:"#f0fdf4", border:"1px solid #bbf7d0", display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, flexShrink:0 }}>✓</div>
              <div style={{ flex:1 }}>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:18, color:"#15803d" }}>PLAN SAVED</div>
                <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#64748b", marginTop:2 }}>Find it in My Plans. Add a gut feel rating after your ride.</div>
              </div>
              <button onClick={()=>setPage("profiles")} style={{ background:"none", border:"1px solid #dde3ee", color:"#64748b", fontFamily:"'Barlow Condensed',sans-serif", fontSize:10, letterSpacing:3, fontWeight:700, padding:"8px 14px", cursor:"pointer", whiteSpace:"nowrap" }}>VIEW PLANS</button>
            </div>
          ) : saveState === "naming" ? (
            // Name + date input
            <div style={{ padding:"20px" }}>
              <div style={{ fontSize:8, letterSpacing:5, color:"#e8000d", fontWeight:700, marginBottom:16 }}>SAVE YOUR PLAN</div>

              {/* Plan name */}
              <div style={{ marginBottom:14 }}>
                <div style={{ fontSize:9, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:6 }}>PLAN NAME</div>
                <input
                  type="text"
                  value={planName}
                  onChange={e=>setPlanName(e.target.value)}
                  placeholder={`${INTENSITY[intensity].zone} ${INTENSITY[intensity].label} · ${hoursNum}h · ${new Date().toLocaleDateString("en-GB",{day:"numeric",month:"short"})}`}
                  style={{ width:"100%", background:"#f8fafc", border:"1px solid #dde3ee", padding:"12px 14px", fontFamily:"'Barlow',sans-serif", fontSize:14, color:"#0f172a", outline:"none" }}
                  autoFocus
                />
              </div>

              {/* Ride date */}
              <div style={{ marginBottom:16 }}>
                <div style={{ fontSize:9, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:6 }}>
                  RIDE DATE <span style={{ fontSize:8, color:"#cbd5e1", letterSpacing:1 }}>(OPTIONAL — enables pre-ride reminders)</span>
                </div>
                <input
                  type="date"
                  value={rideDate}
                  onChange={e=>setRideDate(e.target.value)}
                  min={new Date().toISOString().split("T")[0]}
                  style={{ width:"100%", background:"#f8fafc", border:"1px solid #dde3ee", padding:"12px 14px", fontFamily:"'Barlow Condensed',sans-serif", fontSize:16, fontWeight:700, color:"#0f172a", outline:"none", cursor:"pointer" }}
                />
                {rideDate && (
                  <div style={{ fontSize:10, color:"#9333ea", marginTop:6, fontFamily:"'Barlow',sans-serif", display:"flex", alignItems:"center", gap:6 }}>
                    <span>📅</span>
                    <span>We'll remind you the night before — {new Date(rideDate).toLocaleDateString("en-GB",{weekday:"long",day:"numeric",month:"long"})}</span>
                  </div>
                )}
              </div>

              <div style={{ display:"flex", gap:8 }}>
                <button onClick={()=>setSaveState("idle")} style={{ flex:1, background:"#fff", border:"1px solid #dde3ee", color:"#64748b", fontFamily:"'Barlow Condensed',sans-serif", fontSize:11, letterSpacing:3, fontWeight:700, padding:"11px", cursor:"pointer" }}>CANCEL</button>
                <button onClick={handleSavePlan} style={{ flex:2, background:GRAD, border:"none", color:"#fff", fontFamily:"'Barlow Condensed',sans-serif", fontSize:11, letterSpacing:3, fontWeight:700, padding:"11px", cursor:"pointer" }}>
                  💾 SAVE PLAN
                </button>
              </div>
            </div>
          ) : saveState === "saving" ? (
            // Saving spinner
            <div style={{ padding:"20px", display:"flex", alignItems:"center", gap:14 }}>
              <div style={{ width:20, height:20, borderRadius:"50%", border:"2px solid #e8000d", borderTopColor:"transparent", animation:"spin 1s linear infinite", flexShrink:0 }}/>
              <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:16, letterSpacing:2, color:"#64748b" }}>SAVING...</div>
            </div>
          ) : saveState === "error" ? (
            // Error state
            <div style={{ padding:"20px", display:"flex", alignItems:"center", justifyContent:"space-between", gap:12 }}>
              <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#dc2626" }}>Failed to save. Please try again.</div>
              <button onClick={()=>setSaveState("naming")} style={{ background:"none", border:"1px solid #fca5a5", color:"#dc2626", fontFamily:"'Barlow Condensed',sans-serif", fontSize:10, letterSpacing:3, fontWeight:700, padding:"8px 14px", cursor:"pointer" }}>RETRY</button>
            </div>
          ) : (
            // Default — save button
            <div style={{ padding:"20px", display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:12 }}>
              <div>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:18, marginBottom:4 }}>SAVE THIS PLAN</div>
                <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#64748b", fontWeight:300 }}>Save to My Plans and rate your gut feel after the ride.</div>
              </div>
              <button onClick={()=>setSaveState("naming")} style={{ background:GRAD, border:"none", color:"#fff", fontFamily:"'Barlow Condensed',sans-serif", fontSize:11, letterSpacing:3, fontWeight:700, padding:"11px 22px", cursor:"pointer", whiteSpace:"nowrap" }}>
                💾 SAVE PLAN
              </button>
            </div>
          )}
        </div>

        {/* Disclaimer */}
        <div className="res-card" style={{ fontFamily:"'Barlow',sans-serif", fontSize:11, color:"#94a3b8", padding:"14px 0", lineHeight:1.75 }}>
          <span style={{ fontWeight:600, color:"#64748b" }}>Disclaimer: </span>
          BonkProof estimates are based on sports science guidelines and your inputs — not personalised medical advice. Always practise any fueling strategy in training first. Individual needs vary. BonkProof accepts no liability for adverse effects.
        </div>
      </div>
    </div>
  );

  // ── INPUT SCREEN ───────────────────────────────────────────────────────────
  return (
    <div style={{ background:"#f0f2f7", minHeight:"calc(100vh - 58px)" }}>
      <style>{`
        @keyframes fadeIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
        .inp-section{animation:fadeIn .4s ease both;}
        .inp-section:nth-child(1){animation-delay:.05s}
        .inp-section:nth-child(2){animation-delay:.1s}
        .inp-section:nth-child(3){animation-delay:.15s}
        .inp-section:nth-child(4){animation-delay:.2s}
        .inp-section:nth-child(5){animation-delay:.25s}
        .inp-section:nth-child(6){animation-delay:.3s}
        .inp-section:nth-child(7){animation-delay:.35s}
        .int-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px;}
        .gut-grid{display:flex;flex-direction:column;gap:8px;}
      `}</style>

      <div style={{ maxWidth:560, margin:"0 auto", padding:"28px 16px 48px" }}>

        {/* Header */}
        <div style={{ marginBottom:28, textAlign:"center" }}>
          <SectionLabel>FUELING CALCULATOR</SectionLabel>
          <h1 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:"clamp(28px,6vw,44px)", lineHeight:1, marginBottom:8 }}>TELL US ABOUT YOUR RIDE</h1>
          <p style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#64748b", fontWeight:300, lineHeight:1.7 }}>Fill in your details and we'll calculate your exact fueling plan.</p>
        </div>

        {/* 1. About You */}
        <div className="inp-section" style={{ background:"#fff", border:"1px solid #dde3ee", padding:"22px", marginBottom:12 }}>
          <div style={{ fontSize:8, letterSpacing:5, color:"#e8000d", fontWeight:700, marginBottom:18 }}>01 — ABOUT YOU</div>
          <div style={{ display:"flex", flexDirection:"column", gap:18 }}>

            {/* Weight */}
            <div>
              <div style={{ fontSize:9, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:8 }}>BODY WEIGHT</div>
              <div style={{ display:"flex" }}>
                <input type="number" value={weight} min={30} max={220}
                  onChange={e=>setWeight(e.target.value)}
                  onBlur={e=>{const v=parseFloat(e.target.value);setWeight(isNaN(v)?"70":String(Math.min(220,Math.max(30,v))));}}
                  style={{ ...inp, flex:1, fontSize:52, padding:"10px 14px", borderRight:"none", lineHeight:1 }}/>
                <div style={{ display:"flex", flexDirection:"column" }}>
                  {["kg","lbs"].map(u=>(
                    <button key={u} onClick={()=>setUnit(u)} style={{ flex:1, background:unit===u?"#fef2f8":"#fff", border:"1px solid #dde3ee", borderBottom:u==="kg"?"none":"1px solid #dde3ee", color:unit===u?"#e8000d":"#94a3b8", fontFamily:"'Barlow Condensed',sans-serif", fontSize:12, letterSpacing:2, fontWeight:700, padding:"0 16px", cursor:"pointer", transition:"all .15s" }}>{u.toUpperCase()}</button>
                  ))}
                </div>
              </div>
              {unit==="lbs"&&<div style={{ fontSize:10, color:"#94a3b8", letterSpacing:2, marginTop:6 }}>= {weightKg} KG</div>}
            </div>

            {/* Sex */}
            <div>
              <div style={{ fontSize:9, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:8 }}>BIOLOGICAL SEX</div>
              <div style={{ display:"flex", gap:0 }}>
                {[["male","♂  Male"],["female","♀  Female"]].map(([k,l])=>(
                  <button key={k} onClick={()=>{setSex(k);if(k==="male")setLutealPhase(false);}} style={{ flex:1, background:sex===k?"#fef2f8":"#fff", border:"1px solid #dde3ee", borderRight:k==="male"?"none":"1px solid #dde3ee", color:sex===k?"#e8000d":"#94a3b8", fontFamily:"'Barlow Condensed',sans-serif", fontSize:14, letterSpacing:2, fontWeight:700, padding:"12px 0", cursor:"pointer", transition:"all .15s" }}>{l}</button>
                ))}
              </div>
            </div>

            {/* Luteal — female only */}
            {sex==="female"&&(
              <div style={{ background:"#fdf4ff", border:"1px solid #e9d5ff", padding:"14px 16px" }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <div>
                    <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:14, color:"#7e22ce" }}>Luteal phase boost</div>
                    <div style={{ fontSize:10, color:"#94a3b8", marginTop:3, fontFamily:"'Barlow',sans-serif" }}>+8% carbs · +5% fluid (ISSN 2023)</div>
                  </div>
                  <button onClick={()=>setLutealPhase(p=>!p)} style={{ width:44, height:24, borderRadius:12, background:lutealPhase?"#9333ea":"#dde3ee", border:"none", cursor:"pointer", position:"relative", transition:"background .2s", flexShrink:0 }}>
                    <div style={{ position:"absolute", top:3, left:lutealPhase?22:3, width:18, height:18, borderRadius:"50%", background:"#fff", transition:"left .2s", boxShadow:"0 1px 3px rgba(0,0,0,.2)" }}/>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* 2. Your Ride */}
        <div className="inp-section" style={{ background:"#fff", border:"1px solid #dde3ee", padding:"22px", marginBottom:12 }}>
          <div style={{ fontSize:8, letterSpacing:5, color:"#e8000d", fontWeight:700, marginBottom:18 }}>02 — YOUR RIDE</div>
          <div style={{ display:"flex", flexDirection:"column", gap:18 }}>

            {/* Duration */}
            <div>
              <div style={{ fontSize:9, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:8 }}>DURATION</div>
              <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                <div style={{ flex:1 }}>
                  <input type="number" value={hours} min={0} max={12}
                    onChange={e=>setHours(e.target.value)}
                    onBlur={e=>{const v=parseFloat(e.target.value);setHours(isNaN(v)?"0":String(Math.min(12,Math.max(0,Math.floor(v)))));}}
                    style={{ ...inp, fontSize:48, padding:"8px 12px", width:"100%", textAlign:"center" }}/>
                  <div style={{ fontSize:9, color:"#94a3b8", letterSpacing:3, textAlign:"center", marginTop:4 }}>HOURS</div>
                </div>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:48, color:"#dde3ee", flexShrink:0 }}>:</div>
                <div style={{ flex:1 }}>
                  <input type="number" value={mins} min={0} max={59}
                    onChange={e=>setMins(e.target.value)}
                    onBlur={e=>{const v=parseFloat(e.target.value);setMins(isNaN(v)?"0":String(Math.min(59,Math.max(0,Math.floor(v)))));}}
                    style={{ ...inp, fontSize:48, padding:"8px 12px", width:"100%", textAlign:"center" }}/>
                  <div style={{ fontSize:9, color:"#94a3b8", letterSpacing:3, textAlign:"center", marginTop:4 }}>MINS</div>
                </div>
              </div>
            </div>

            {/* Intensity zones */}
            <div>
              <div style={{ fontSize:9, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:8 }}>RIDE INTENSITY ZONE</div>
              <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                {Object.entries(INTENSITY).map(([k,p])=>{
                  const on=intensity===k; const c=INT_COLORS[k];
                  return (
                    <button key={k} onClick={()=>setIntensity(k)} style={{ background:on?"#fef2f8":"#fff", border:`1.5px solid ${on?c:"#dde3ee"}`, padding:"12px 14px", cursor:"pointer", textAlign:"left", display:"flex", alignItems:"center", gap:14, transition:"all .15s" }}>
                      {/* Zone badge */}
                      <div style={{ width:36, height:36, borderRadius:"50%", background:on?c:"#f1f5f9", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, transition:"background .15s" }}>
                        <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:13, color:on?"#fff":"#94a3b8", letterSpacing:0 }}>{p.zone}</span>
                      </div>
                      <div style={{ flex:1 }}>
                        <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:800, fontSize:17, color:on?c:"#64748b", letterSpacing:.5, lineHeight:1 }}>{p.label}</div>
                        <div style={{ fontSize:10, color:"#94a3b8", marginTop:3, fontFamily:"'Barlow',sans-serif" }}>{p.sub}</div>
                      </div>
                      <div style={{ textAlign:"right", flexShrink:0 }}>
                        <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:22, color:on?c:"#e2e8f0", lineHeight:1 }}>{p.baseCarbHr}<span style={{ fontSize:10, color:"#94a3b8", fontWeight:700 }}>g+</span></div>
                        <div style={{ fontSize:8, color:"#94a3b8", letterSpacing:2 }}>/HR BASE</div>
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* 3. Gut Training */}
        <div className="inp-section" style={{ background:"#fff", border:"1px solid #dde3ee", padding:"22px", marginBottom:12 }}>
          <div style={{ fontSize:8, letterSpacing:5, color:"#e8000d", fontWeight:700, marginBottom:6 }}>03 — GUT TRAINING LEVEL</div>
          <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:12, color:"#94a3b8", marginBottom:16, fontWeight:300, lineHeight:1.6 }}>How trained is your gut to absorb carbs during exercise?</div>
          <div className="gut-grid">
            {Object.entries(GUT).map(([k,g])=>{
              const on=gut===k;
              return (
                <button key={k} onClick={()=>setGut(k)} style={{ background:on?"#fef2f8":"#fff", border:`1.5px solid ${on?"#e8000d":"#dde3ee"}`, padding:"14px 16px", cursor:"pointer", textAlign:"left", display:"flex", justifyContent:"space-between", alignItems:"center", transition:"all .15s" }}>
                  <div>
                    <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:17, color:on?"#0f172a":"#64748b", letterSpacing:.5 }}>{g.label}</div>
                    <div style={{ fontSize:10, color:"#94a3b8", marginTop:3, fontFamily:"'Barlow',sans-serif" }}>{g.sub}</div>
                  </div>
                  <div style={{ textAlign:"right", flexShrink:0, marginLeft:12 }}>
                    <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:28, color:on?"#e8000d":"#e2e8f0" }}>{g.max}</span>
                    <div style={{ fontSize:8, color:"#94a3b8", letterSpacing:2 }}>G/HR MAX</div>
                  </div>
                </button>
              );
            })}
          </div>
        </div>

        {/* 4. Conditions */}
        <div className="inp-section" style={{ background:"#fff", border:"1px solid #dde3ee", padding:"22px", marginBottom:28 }}>
          <div style={{ fontSize:8, letterSpacing:5, color:"#e8000d", fontWeight:700, marginBottom:6 }}>04 — CONDITIONS</div>
          <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:12, color:"#94a3b8", marginBottom:18, fontWeight:300, lineHeight:1.6 }}>Where and when are you riding?</div>
          <div style={{ display:"flex", flexDirection:"column", gap:22 }}>

            {/* Temperature */}
            <div>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"baseline", marginBottom:10 }}>
                <div style={{ fontSize:9, letterSpacing:3, color:"#94a3b8", fontWeight:700 }}>TEMPERATURE</div>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:32, color:temp>32?"#e8000d":temp>25?"#3b82f6":"#0f172a", lineHeight:1 }}>{temp}<span style={{ fontSize:16 }}>°C</span></div>
              </div>
              <input type="range" min={0} max={45} value={temp} onChange={e=>setTemp(Number(e.target.value))} style={{ width:"100%", marginBottom:6 }}/>
              <div style={{ display:"flex", justifyContent:"space-between", fontSize:9, color:"#cbd5e1", letterSpacing:1 }}>
                <span>0°C</span>
                <span style={{ color:temp>15?"#e8000d":"#cbd5e1", fontWeight:700 }}>{temp>32?"EXTREME HEAT ⚠":temp>25?"HOT ☀":temp>15?"WARM":"COOL"}</span>
                <span>45°C</span>
              </div>
            </div>

            {/* Altitude */}
            <div>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"baseline", marginBottom:10 }}>
                <div style={{ fontSize:9, letterSpacing:3, color:"#94a3b8", fontWeight:700 }}>ALTITUDE</div>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:32, color:altitude>2000?"#e8000d":altitude>1000?"#3b82f6":"#0f172a", lineHeight:1 }}>{altitude}<span style={{ fontSize:16 }}>m</span></div>
              </div>
              <input type="range" min={0} max={4000} step={100} value={altitude} onChange={e=>setAltitude(Number(e.target.value))} style={{ width:"100%", marginBottom:6 }}/>
              <div style={{ display:"flex", justifyContent:"space-between", fontSize:9, color:"#cbd5e1", letterSpacing:1 }}>
                <span>Sea level</span>
                <span style={{ color:altitude>=1000?"#e8000d":"#cbd5e1", fontWeight:700 }}>{altitude>=3000?"VERY HIGH ⛰":altitude>=2000?"HIGH ALT":altitude>=1000?"MODERATE ALT":"SEA LEVEL"}</span>
                <span>4000m</span>
              </div>
            </div>
          </div>
        </div>

        {/* Generate button */}
        <button onClick={generate} style={{
          width:"100%", background:GRAD, border:"none", color:"#fff",
          fontFamily:"'Barlow Condensed',sans-serif", fontSize:16, letterSpacing:6, fontWeight:700,
          padding:"18px", cursor:"pointer", position:"relative", overflow:"hidden",
        }}>
          <style>{`.gen-btn:hover{opacity:.9;transform:translateY(-1px);} .gen-btn:active{transform:translateY(0);}`}</style>
          ⚡ CALCULATE MY PLAN
        </button>

        <div style={{ textAlign:"center", marginTop:12, fontSize:11, color:"#94a3b8", fontFamily:"'Barlow',sans-serif", lineHeight:1.7 }}>
          Based on peer-reviewed sports science. Free. No account required.
        </div>
      </div>
    </div>
  );
}

// ── SAVED PLANS ──────────────────────────────────────────────────────────────

function PlanModal({ plan, onClose, onUpdate }) {
  const [note,         setNote]         = useState(plan.notes || "");
  const [rating,       setRating]       = useState(plan.gut_feel_rating || 0);
  const [saving,       setSaving]       = useState(false);
  const [saved,        setSaved]        = useState(false);
  const [dirty,        setDirty]        = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);

  const FEELING_LABELS = { 0:"Not rated", 1:"Awful", 2:"Rough", 3:"OK", 4:"Good", 5:"Perfect" };

  const handleRating = (n) => { setRating(n); setDirty(true); setSaved(false); };
  const handleNote   = (v) => { setNote(v);   setDirty(true); setSaved(false); };

  const handleSave = async () => {
    setSaving(true);
    if (onUpdate) await onUpdate(plan.id, { notes: note, gut_feel_rating: rating });
    setSaving(false);
    setSaved(true);
    setDirty(false);
  };

  const handleClose = () => {
    if (dirty) { setConfirmClose(true); return; }
    onClose();
  };

  // Normalise fields
  const zone     = plan.zone || plan.intensity || "";
  const ic       = INT_COLORS[zone.toLowerCase()] || "#64748b";
  const planName = plan.name || zone.toUpperCase();
  const dateStr  = plan.created_at || plan.date || "";
  const dateObj  = dateStr ? new Date(dateStr) : new Date();
  const dateLabel= dateObj.toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"});
  const carbs    = plan.carbs_total    || plan.carbs   || 0;
  const cph      = plan.carbs_per_hour || plan.cph     || 0;
  const fluidL   = plan.fluid_total_ml ? (plan.fluid_total_ml/1000).toFixed(1) : (plan.fluid||0);
  const sodium   = plan.sodium_total_mg|| plan.sodium  || 0;
  const temp     = plan.temp_celsius   ?? plan.temp    ?? "—";
  const altitude = plan.altitude_m     ?? plan.altitude?? 0;
  const duration = plan.duration_hours ? `${plan.duration_hours}hr` : (plan.duration||"—");
  const ratio    = plan.carb_ratio     || plan.ratio   || "—";
  const brand    = plan.brand_selected || plan.brand   || "—";

  return (
    <div onClick={handleClose} style={{ position:"fixed", inset:0, zIndex:300, background:"rgba(15,23,42,.55)", backdropFilter:"blur(6px)", display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:"#fff", maxWidth:580, width:"100%", maxHeight:"90vh", overflowY:"auto", border:"1px solid #dde3ee", boxShadow:"0 24px 64px rgba(0,0,0,.15)" }}>

        {/* Unsaved changes warning */}
        {confirmClose && (
          <div style={{ background:"#fff7ed", border:"1px solid #fed7aa", padding:"14px 18px", display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap" }}>
            <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#c2410c" }}>⚠ You have unsaved changes</div>
            <div style={{ display:"flex", gap:8 }}>
              <button onClick={()=>setConfirmClose(false)} style={{ background:"#fff", border:"1px solid #dde3ee", color:"#64748b", fontFamily:"'Barlow Condensed',sans-serif", fontSize:10, letterSpacing:2, fontWeight:700, padding:"6px 14px", cursor:"pointer" }}>KEEP EDITING</button>
              <button onClick={onClose} style={{ background:"#c2410c", border:"none", color:"#fff", fontFamily:"'Barlow Condensed',sans-serif", fontSize:10, letterSpacing:2, fontWeight:700, padding:"6px 14px", cursor:"pointer" }}>EXIT WITHOUT SAVING</button>
            </div>
          </div>
        )}

        {/* Header */}
        <div style={{ padding:"18px 20px", borderBottom:"1px solid #f1f5f9", display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
          <div>
            <div style={{ fontSize:8, letterSpacing:4, color:"#94a3b8", fontWeight:700, marginBottom:5 }}>SAVED PLAN · {dateLabel}</div>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:20, marginBottom:8 }}>{planName}</div>
            <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
              <Tag label={zone.toUpperCase()} color={ic}/>
              {brand!=="—"&&<Tag label={brand.toUpperCase()} color="#64748b"/>}
            </div>
          </div>
          <button onClick={handleClose} style={{ background:"none", border:"1px solid #dde3ee", width:30, height:30, cursor:"pointer", fontSize:16, color:"#94a3b8", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>×</button>
        </div>

        <div style={{ padding:18, display:"flex", flexDirection:"column", gap:12 }}>
          {/* Stats */}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:8 }}>
            {[["TOTAL CARBS",`${carbs}g`],["PER HOUR",`${cph}g/hr`],["FLUID",`${fluidL}L`],["SODIUM",`${sodium}mg`]].map(([l,v])=>(
              <div key={l} style={{ background:"#fef2f8", border:"1px solid #dde3ee", padding:"12px 14px", textAlign:"center" }}>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:24, background:GRAD, WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>{v}</div>
                <div style={{ fontSize:8, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginTop:4 }}>{l}</div>
              </div>
            ))}
          </div>

          {/* Conditions */}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:8 }}>
            {[["Duration",duration],["Temp",`${temp}°C`],["Altitude",`${altitude}m`],["Ratio",ratio]].map(([l,v])=>(
              <div key={l} style={{ background:"#f8fafc", border:"1px solid #dde3ee", padding:"10px" }}>
                <div style={{ fontSize:8, letterSpacing:2, color:"#94a3b8", fontWeight:700 }}>{l.toUpperCase()}</div>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:14, marginTop:3 }}>{v}</div>
              </div>
            ))}
          </div>

          {/* Ride date */}
          {plan.ride_date && (
            <div style={{ background:"#fdf4ff", border:"1px solid #e9d5ff", padding:"10px 14px", display:"flex", alignItems:"center", gap:10 }}>
              <span style={{ fontSize:16 }}>📅</span>
              <div>
                <div style={{ fontSize:8, letterSpacing:3, color:"#9333ea", fontWeight:700, marginBottom:2 }}>RIDE DATE</div>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:15 }}>
                  {new Date(plan.ride_date).toLocaleDateString("en-GB",{weekday:"long",day:"numeric",month:"long",year:"numeric"})}
                </div>
              </div>
            </div>
          )}

          {/* Gut feel rating */}
          <div style={{ background:"#fef2f8", border:"1px solid #dde3ee", padding:"14px 16px" }}>
            <div style={{ fontSize:8, letterSpacing:4, color:"#94a3b8", fontWeight:700, marginBottom:10 }}>GUT FEEL RATING</div>
            <div style={{ display:"flex", gap:4, alignItems:"center", flexWrap:"wrap" }}>
              {[1,2,3,4,5].map(n=>(
                <button key={n} onClick={()=>handleRating(n)} style={{ background:"none", border:"none", cursor:"pointer", fontSize:34, color:n<=rating?"#e8000d":"#dde3ee", transition:"color .15s", padding:"2px 4px" }}>★</button>
              ))}
              <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:15, color:"#64748b", marginLeft:8, fontWeight:700 }}>{FEELING_LABELS[rating]}</span>
            </div>
          </div>

          {/* Notes — always editable */}
          <div>
            <div style={{ fontSize:8, letterSpacing:4, color:"#94a3b8", fontWeight:700, marginBottom:8 }}>POST-RIDE NOTES</div>
            <textarea
              value={note}
              onChange={e=>handleNote(e.target.value)}
              placeholder="How did your fueling feel? What would you change next time?"
              style={{ width:"100%", background:"#f8faff", border:"1px solid #dde3ee", padding:12, fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#334155", lineHeight:1.7, resize:"vertical", minHeight:80, outline:"none" }}
            />
          </div>

          {/* Single save button */}
          <button
            onClick={handleSave}
            disabled={saving}
            style={{
              width:"100%", border:"none",
              cursor: saving ? "not-allowed" : "pointer",
              background: saved && !dirty ? "#f0fdf4" : GRAD,
              color: saved && !dirty ? "#15803d" : "#fff",
              fontFamily:"'Barlow Condensed',sans-serif", fontSize:13, letterSpacing:4, fontWeight:700,
              padding:"14px", transition:"all .2s",
              outline: saved && !dirty ? "1px solid #bbf7d0" : "none",
            }}
          >
            {saving ? "SAVING..." : saved && !dirty ? "✓ CHANGES SAVED" : "💾 SAVE CHANGES"}
          </button>
        </div>
      </div>
    </div>
  );
}

function Profiles({ setPage, user, loadPlans, updatePlan, deletePlan }) {
  const [plans,    setPlans]    = useState([]);
  const [loadingP, setLoadingP] = useState(true);
  const [selected, setSelected] = useState(null);
  const [filter,   setFilter]   = useState("All");
  const [search,   setSearch]   = useState("");
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    if (!user) return;
    setLoadingP(true);
    loadPlans().then(rows => {
      setPlans(rows);
      setLoadingP(false);
    });
  }, [user]);

  const filtered = plans
    .filter(p => p != null)
    .filter(p => filter==="All" || (p.zone||p.intensity||"").toUpperCase()===filter)
    .filter(p => (p.name||"").toLowerCase().includes(search.toLowerCase()) || (p.notes||"").toLowerCase().includes(search.toLowerCase()));

  const handleUpdatePlan = async (planId, updates) => {
    await updatePlan(planId, updates);
    setPlans(ps => ps.map(p => p.id === planId ? { ...p, ...updates } : p));
    // Also update selected so modal shows fresh data immediately
    setSelected(s => s && s.id === planId ? { ...s, ...updates } : s);
  };

  const handleDelete = async (planId) => {
    await deletePlan(planId);
    setPlans(ps => ps.filter(p => p.id !== planId));
    setDeleteId(null);
  };

  // Not logged in — show sign in prompt
  if (!user) return (
    <div style={{ background:"#f0f2f7", minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ background:"#fff", border:"1px solid #dde3ee", padding:"48px 32px", maxWidth:420, width:"100%", textAlign:"center", boxShadow:"0 4px 24px rgba(0,0,0,.06)" }}>
        <div style={{ fontSize:48, marginBottom:16 }}>📋</div>
        <div style={{ fontSize:8, letterSpacing:5, color:"#e8000d", fontWeight:700, marginBottom:10 }}>MY PLANS</div>
        <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:28, marginBottom:12, lineHeight:1 }}>SIGN IN TO VIEW YOUR PLANS</div>
        <p style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#64748b", lineHeight:1.7, fontWeight:300, marginBottom:28 }}>
          Create a free account to save your fueling plans and access them before every ride.
        </p>
        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          <Btn onClick={()=>setPage("auth")} style={{ width:"100%", justifyContent:"center", fontSize:13, padding:"13px" }}>
            SIGN IN / CREATE ACCOUNT
          </Btn>
          <button onClick={()=>setPage("calculator")} style={{ background:"none", border:"1px solid #dde3ee", color:"#64748b", fontFamily:"'Barlow Condensed',sans-serif", fontSize:11, letterSpacing:3, fontWeight:700, padding:"11px", cursor:"pointer" }}>
            USE CALCULATOR INSTEAD
          </button>
          <button onClick={()=>setPage("landing")} style={{ background:"none", border:"none", color:"#94a3b8", fontFamily:"'Barlow',sans-serif", fontSize:12, cursor:"pointer", marginTop:4 }}>
            ← Back to home
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ background:"#f0f2f7", minHeight:"100vh", padding:"28px 20px" }}>
      <style>{`
        .plan-card{background:#fff;border:1px solid #dde3ee;padding:18px 20px;cursor:pointer;transition:all .2s;position:relative;overflow:hidden;}
        .plan-card:hover{border-color:#e8000d44;box-shadow:0 4px 16px rgba(232,0,13,.06);transform:translateX(2px);}
        .plan-actions{opacity:0;transition:opacity .2s;}
        .plan-card:hover .plan-actions{opacity:1;}
        .pcard-grid{display:grid;grid-template-columns:auto 1fr auto;gap:16px;align-items:center;}
        @media(max-width:600px){.pcard-grid{grid-template-columns:1fr;gap:10px;}.plan-actions{opacity:1;}}
      `}</style>
      <div style={{ maxWidth:1000, margin:"0 auto" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:22, flexWrap:"wrap", gap:12 }}>
          <div>
            <SectionLabel>MY PLANS</SectionLabel>
            <h1 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:"clamp(28px,5vw,42px)", lineHeight:1 }}>FUELING HISTORY</h1>
            <p style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#64748b", marginTop:5, fontWeight:300 }}>Save, revisit and refine every ride's nutrition plan.</p>
          </div>
          <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
            <button onClick={()=>setPage("landing")} style={{ background:"#fff", border:"1px solid #dde3ee", color:"#64748b", fontFamily:"'Barlow Condensed',sans-serif", fontSize:10, letterSpacing:3, fontWeight:700, padding:"8px 14px", cursor:"pointer" }}>← HOME</button>
            <Btn onClick={()=>setPage("calculator")}>+ NEW PLAN</Btn>
          </div>
        </div>

        {/* Filters */}
        <div style={{ display:"flex", gap:8, marginBottom:16, flexWrap:"wrap" }}>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search plans..." style={{ flex:1, minWidth:150, background:"#fff", border:"1px solid #dde3ee", padding:"8px 12px", fontFamily:"'Barlow Condensed',sans-serif", fontSize:12, letterSpacing:1, outline:"none" }}/>
          {["All","Z1","Z2","Z3","Z4","Z5"].map(f=>(
            <button key={f} onClick={()=>setFilter(f)} style={{ background:filter===f?"#fef2f8":"#fff", border:`1px solid ${filter===f?"#e8000d44":"#dde3ee"}`, color:filter===f?"#e8000d":"#64748b", fontFamily:"'Barlow Condensed',sans-serif", fontSize:10, letterSpacing:2, fontWeight:700, padding:"8px 12px", cursor:"pointer" }}>{f}</button>
          ))}
        </div>

        {/* Loading state */}
        {loadingP && (
          <div style={{ background:"#fff", border:"1px solid #dde3ee", padding:"48px 20px", textAlign:"center" }}>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:12, letterSpacing:4, color:"#94a3b8" }}>LOADING YOUR PLANS...</div>
          </div>
        )}

        {/* Empty state — logged in but no plans yet */}
        {!loadingP && plans.length === 0 && (
          <div style={{ background:"#fff", border:"1px solid #dde3ee", padding:"64px 20px", textAlign:"center" }}>
            <div style={{ fontSize:48, marginBottom:16 }}>⚡</div>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:24, marginBottom:10 }}>NO PLANS YET</div>
            <p style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#64748b", lineHeight:1.7, fontWeight:300, marginBottom:24, maxWidth:320, margin:"0 auto 24px" }}>
              Use the calculator to build your first fueling plan. Save it and it'll appear here before every ride.
            </p>
            <Btn onClick={()=>setPage("calculator")}>BUILD YOUR FIRST PLAN</Btn>
          </div>
        )}

        <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
          {filtered.length===0 && plans.length > 0 &&(
            <div style={{ background:"#fff", border:"1px solid #dde3ee", padding:"48px 20px", textAlign:"center" }}>
              <div style={{ fontSize:36, marginBottom:12 }}>📋</div>
              <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:20 }}>No plans match your search</div>
              <button onClick={()=>{setSearch("");setFilter("All");}} style={{ background:"none", border:"none", color:"#e8000d", fontFamily:"'Barlow Condensed',sans-serif", fontSize:11, letterSpacing:3, fontWeight:700, cursor:"pointer", marginTop:12 }}>CLEAR FILTERS</button>
            </div>
          )}
          {filtered.map(p => {
            const ic = INT_COLORS[(p.zone||p.intensity||"z4").toLowerCase()] || "#64748b";
            const d = new Date(p.created_at || p.date || Date.now());
            const day = d.getDate().toString().padStart(2,"0");
            const mon = d.toLocaleString("default",{month:"short"}).toUpperCase();
            const yr  = d.getFullYear();
            const planName = p.name || `${(p.zone||"").toUpperCase()} · ${p.duration_hours||"?"}hr`;
            const zone = (p.zone || p.intensity || "").toUpperCase();
            const duration = p.duration_hours ? `${p.duration_hours}hr` : (p.duration||"");
            const carbs = p.carbs_total || p.carbs || 0;
            const cph   = p.carbs_per_hour || p.cph || 0;
            const fluid = p.fluid_total_ml ? (p.fluid_total_ml/1000).toFixed(1) : (p.fluid||0);
            return (
              <div key={p.id}>
                <div className="plan-card" onClick={()=>setSelected(p)}>
                  <div style={{ position:"absolute", left:0, top:0, bottom:0, width:3, background:ic }}/>
                  <div className="pcard-grid" style={{ paddingLeft:8 }}>
                    <div style={{ textAlign:"center", minWidth:48 }}>
                      <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:28, lineHeight:1 }}>{day}</div>
                      <div style={{ fontSize:8, letterSpacing:2, color:"#94a3b8", fontWeight:700 }}>{mon} {yr}</div>
                    </div>
                    <div>
                      <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:18, marginBottom:4 }}>{planName}</div>
                      <div style={{ display:"flex", gap:8, flexWrap:"wrap", alignItems:"center" }}>
                        <span style={{ fontSize:9, letterSpacing:2, color:ic, fontWeight:700 }}>{zone}</span>
                        {duration&&<><span style={{ color:"#dde3ee" }}>·</span><span style={{ fontSize:9, letterSpacing:2, color:"#94a3b8" }}>{duration}</span></>}
                        {p.temp_celsius!=null&&<><span style={{ color:"#dde3ee" }}>·</span><span style={{ fontSize:9, color:"#94a3b8" }}>{p.temp_celsius}°C · {p.altitude_m||0}m</span></>}
                      </div>
                    </div>
                    <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:12 }}>
                      <div style={{ display:"flex", gap:14 }}>
                        <div style={{ textAlign:"right" }}>
                          <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:800, fontSize:20, background:GRAD, WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>{carbs}g</div>
                          <div style={{ fontSize:8, letterSpacing:2, color:"#94a3b8" }}>CARBS</div>
                        </div>
                        <div style={{ textAlign:"right" }}>
                          <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:800, fontSize:20, color:"#e8000d" }}>{cph}</div>
                          <div style={{ fontSize:8, letterSpacing:2, color:"#94a3b8" }}>G/HR</div>
                        </div>
                        <div style={{ textAlign:"right" }}>
                          <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:800, fontSize:20, color:"#0f172a" }}>{fluid}L</div>
                          <div style={{ fontSize:8, letterSpacing:2, color:"#94a3b8" }}>FLUID</div>
                        </div>
                      </div>
                      <div className="plan-actions" style={{ display:"flex", gap:6 }} onClick={e=>e.stopPropagation()}>
                        <button title="Delete" onClick={()=>setDeleteId(p.id)} style={{ background:"none", border:"1px solid #dde3ee", color:"#94a3b8", width:26, height:26, display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer", fontSize:12 }}>✕</button>
                      </div>
                    </div>
                  </div>
                </div>
                {deleteId===p.id&&(
                  <div style={{ background:"#fff", border:"1px solid #fca5a5", padding:"12px 16px", display:"flex", justifyContent:"space-between", alignItems:"center", gap:10, flexWrap:"wrap" }}>
                    <span style={{ fontFamily:"'Barlow',sans-serif", fontSize:12, color:"#dc2626" }}>Delete "{planName}"?</span>
                    <div style={{ display:"flex", gap:6 }}>
                      <button onClick={()=>setDeleteId(null)} style={{ background:"#fff", border:"1px solid #dde3ee", color:"#64748b", fontFamily:"'Barlow Condensed',sans-serif", fontSize:10, letterSpacing:2, fontWeight:700, padding:"6px 12px", cursor:"pointer" }}>CANCEL</button>
                      <button onClick={()=>handleDelete(p.id)} style={{ background:"#dc2626", border:"none", color:"#fff", fontFamily:"'Barlow Condensed',sans-serif", fontSize:10, letterSpacing:2, fontWeight:700, padding:"6px 12px", cursor:"pointer" }}>DELETE</button>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      {selected&&<PlanModal plan={selected} onClose={()=>setSelected(null)} onUpdate={handleUpdatePlan}/>}
    </div>
  );
}

// ── SCIENCE ──────────────────────────────────────────────────────────────────
const RATIO_DATA = [
  { intake:"Up to 60g/hr", ratio:"Glucose only", transport:"SGLT1 only",    note:"Single transporter — fructose adds no benefit at this rate." },
  { intake:"60–90g/hr",    ratio:"2:1",          transport:"SGLT1 + GLUT5", note:"Dual transporter unlocked. 2:1 is the established optimal ratio." },
  { intake:"90–120g/hr",   ratio:"1:0.8",        transport:"SGLT1 + GLUT5", note:"Higher fructose proportion maximises total absorption capacity." },
  { intake:"120g/hr+",     ratio:"1:0.8",        transport:"SGLT1 + GLUT5", note:"Elite gut-trained athletes only. Requires systematic adaptation." },
];
const GUT_STAGES = [
  { stage:"01", title:"Untrained",    range:"Up to 60g/hr",  duration:"No prior training",              color:"#22c55e", desc:"The gut's transporter proteins are at baseline capacity. Most recreational athletes fall here. Exceeding 60g/hr typically causes GI distress." },
  { stage:"02", title:"Developing",   range:"60–75g/hr",     duration:"4–8 weeks consistent practice",  color:"#3b82f6", desc:"Transporter upregulation begins. The gut starts adapting to higher carbohydrate loads during exercise. Consistency is key." },
  { stage:"03", title:"Trained",      range:"75–90g/hr",     duration:"3–6 months",                     color:"#3b82f6", desc:"Established dual-transporter function. The athlete can reliably absorb mixed carbohydrate sources without significant GI distress." },
  { stage:"04", title:"Elite Trained",range:"120–150g/hr",   duration:"6–18 months systematic training",color:"#e8000d", desc:"Maximum transporter upregulation. Achieved by professional cyclists and those who have systematically trained their gut over extended periods." },
];
const HEAT_TABLE=[{temp:"≤15°C",fluid:"+0%",sodium:"+0%",label:"Cool"},{temp:"16–25°C",fluid:"+15%",sodium:"+20%",label:"Warm"},{temp:"26–32°C",fluid:"+30%",sodium:"+40%",label:"Hot"},{temp:"33°C+",fluid:"+50%",sodium:"+60%",label:"Extreme Heat"}];
const ALT_TABLE=[{alt:"Sea level–999m",carbs:"+0%",label:"No adjustment"},{alt:"1,000–1,999m",carbs:"+5%",label:"Moderate altitude"},{alt:"2,000–2,999m",carbs:"+10%",label:"High altitude"},{alt:"3,000m+",carbs:"+15%",label:"Very high altitude"}];

// ── SCIENCE CHAPTER COMPONENTS ────────────────────────────────────────────────
const S_PROSE = { fontFamily:"'Barlow',sans-serif", fontSize:15, color:"#475569", lineHeight:1.8, fontWeight:400 };
const S_SC    = { fontFamily:"'Barlow Condensed',sans-serif" };

function SciCallout({ children, color="#e8000d" }) {
  return (
    <div style={{ borderLeft:`3px solid ${color}`, background:`${color}0d`, padding:"16px 20px", margin:"24px 0", ...S_PROSE, fontSize:14, color:"#334155" }}>
      {children}
    </div>
  );
}

function SciStatCard({ number, unit, label, color="#e8000d" }) {
  return (
    <div style={{ background:"#fff", border:"1px solid rgba(0,0,0,0.07)", borderRadius:14, padding:"24px 20px", textAlign:"center", position:"relative", overflow:"hidden" }}>
      <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:`linear-gradient(90deg,${color},#3b82f6)` }}/>
      <div style={{ ...S_SC, fontWeight:900, fontSize:42, lineHeight:1, background:`linear-gradient(135deg,${color},#3b82f6)`, WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>{number}</div>
      <div style={{ fontSize:10, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginTop:4, ...S_SC }}>{unit}</div>
      <div style={{ fontSize:13, color:"#64748b", marginTop:8, lineHeight:1.5 }}>{label}</div>
    </div>
  );
}

function SciTable({ heads, rows }) {
  return (
    <div style={{ overflowX:"auto", borderRadius:12, border:"1px solid rgba(0,0,0,0.07)", overflow:"hidden" }}>
      <table style={{ width:"100%", borderCollapse:"collapse" }}>
        <thead>
          <tr style={{ background:"#0f172a" }}>
            {heads.map(h => <th key={h} style={{ ...S_SC, fontSize:10, letterSpacing:3, fontWeight:700, padding:"12px 16px", textAlign:"left", color:"rgba(255,255,255,0.6)" }}>{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} style={{ background: i%2===0 ? "#fff" : "#f8fafc" }}>
              {row.map((cell, j) => (
                <td key={j} style={{ padding:"11px 16px", fontSize:13, color:"#334155", fontFamily:"'Barlow',sans-serif", borderBottom:"1px solid rgba(0,0,0,0.05)" }}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function SciCarbs() {
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:32 }}>
      <div style={S_PROSE}>
        <p>During high-intensity exercise, your muscles oxidise carbohydrate at rates your liver and muscle glycogen stores cannot sustain beyond 60–90 minutes. This is the bonk — not a failure of willpower, but a biochemical reality.</p>
        <br/><p>BonkProof calculates your carbohydrate target based on ride intensity — the primary driver of oxidation rate — multiplied by ride duration and scaled by your body mass (Ijaz et al. 2024) and biological sex (Devries 2006).</p>
      </div>
      <SciCallout>At threshold and above, your body can oxidise up to 1.5–1.8g of carbohydrate per minute — far exceeding what an untrained gut can absorb. This gap is the entire reason gut training matters.</SciCallout>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:10 }}>
        <SciStatCard number="30" unit="G/HR" label="Easy baseline" color="#22c55e"/>
        <SciStatCard number="60" unit="G/HR" label="Moderate baseline" color="#3b82f6"/>
        <SciStatCard number="90" unit="G/HR" label="Race baseline" color="#f97316"/>
        <SciStatCard number="120" unit="G/HR MAX" label="Elite gut ceiling" color="#e8000d"/>
      </div>
    </div>
  );
}

function SciTransport() {
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:32 }}>
      <div style={S_PROSE}>
        <p>Glucose uses SGLT1 (sodium-glucose cotransporter), which saturates at ~60g/hr. Fructose uses GLUT5 — a separate transporter — with its own capacity of ~30–40g/hr. By combining both, you access dual transporters simultaneously.</p>
        <br/><p>Maltodextrin is preferred over pure glucose because it's less sweet, osmotically lighter, and easier on the stomach at high concentrations.</p>
      </div>
      <SciCallout color="#3b82f6">The 2:1 maltodextrin:fructose ratio was established as optimal up to 90g/hr. Above that, the ratio shifts to 1:0.8 to hit the ceiling of both transporters.</SciCallout>
      <SciTable
        heads={["Intake Rate","Ratio","Transporters","Notes"]}
        rows={RATIO_DATA.map(r=>[r.intake,r.ratio,r.transport,r.note])}
      />
      <div style={{ background:"#fff", border:"1px solid rgba(0,0,0,0.07)", borderRadius:14, padding:"24px" }}>
        <div style={{ fontSize:10, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:16, ...S_SC }}>TRANSPORTER CAPACITY</div>
        {[{l:"SGLT1 — Glucose / Maltodextrin",cap:60,pct:55,c:"#e8000d"},{l:"GLUT5 — Fructose",cap:40,pct:36,c:"#3b82f6"},{l:"Combined (Trained gut)",cap:100,pct:91,c:"#22c55e"}].map(t=>(
          <div key={t.l} style={{ marginBottom:14 }}>
            <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, color:"#64748b", marginBottom:6 }}>
              <span>{t.l}</span>
              <span style={{ ...S_SC, fontWeight:700, color:t.c }}>{t.cap}g/hr</span>
            </div>
            <div style={{ height:5, background:"#f1f5f9", borderRadius:3, overflow:"hidden" }}>
              <div style={{ width:`${t.pct}%`, height:"100%", background:t.c, borderRadius:3 }}/>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function SciGut() {
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:32 }}>
      <div style={S_PROSE}>
        <p>The small intestine's absorptive capacity is not static. Consistent exposure to high carbohydrate intake during exercise upregulates the transporter proteins responsible for absorption. This is gut training — the difference between an athlete who handles 60g/hr and one who absorbs 120g/hr without distress.</p>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:10 }}>
        {GUT_STAGES.map(s=>(
          <div key={s.stage} style={{ background:"#fff", border:"1px solid rgba(0,0,0,0.07)", borderRadius:14, padding:"24px", position:"relative", overflow:"hidden" }}>
            <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:s.color }}/>
            <div style={{ ...S_SC, fontWeight:900, fontSize:56, color:"rgba(0,0,0,0.04)", lineHeight:1, position:"absolute", top:8, right:16 }}>{s.stage}</div>
            <div style={{ ...S_SC, fontWeight:700, fontSize:18, color:"#0f172a", marginBottom:6 }}>{s.title}</div>
            <div style={{ display:"inline-block", padding:"3px 10px", borderRadius:20, fontSize:12, fontWeight:700, marginBottom:8, background:`${s.color}15`, color:s.color }}>{s.range}</div>
            <div style={{ fontSize:10, letterSpacing:2, color:"#94a3b8", fontWeight:700, marginBottom:10, ...S_SC }}>{s.duration.toUpperCase()}</div>
            <div style={{ fontSize:13, color:"#64748b", lineHeight:1.65 }}>{s.desc}</div>
          </div>
        ))}
      </div>
      <SciCallout color="#22c55e">If you're training your gut: start at your current tolerance, add 10–15g/hr every 2–3 weeks, and practise on longer training rides — not race day.</SciCallout>
    </div>
  );
}

function SciFluid() {
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:32 }}>
      <div style={S_PROSE}>
        <p>BonkProof calculates fluid targets as ml per kg of body weight per hour — sweat rate genuinely scales with body mass (Baker 2017; Notley 2023). Baselines range from 6ml/kg/hr at easy intensity up to 12ml/kg/hr at race effort, then adjusted for temperature.</p>
        <br/><p>The target is to replace approximately 80% of fluid losses — not 100%. Attempting full replacement risks hyponatraemia, particularly in cooler conditions.</p>
      </div>
      <SciCallout color="#3b82f6">Thirst is a lagging indicator — you're already mildly dehydrated before you feel it. Drink to a schedule based on your plan, especially in heat.</SciCallout>
      <div style={{ background:"#fff", border:"1px solid rgba(0,0,0,0.07)", borderRadius:14, padding:"24px" }}>
        <div style={{ fontSize:10, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:20, ...S_SC }}>BASELINE FLUID RATES BY INTENSITY</div>
        {[{l:"Easy / Recovery",rate:"6ml/kg/hr",pct:50,c:"#22c55e"},{l:"Moderate Endurance",rate:"8ml/kg/hr",pct:67,c:"#3b82f6"},{l:"Threshold / Hard",rate:"10ml/kg/hr",pct:83,c:"#f97316"},{l:"Race / Max Effort",rate:"12ml/kg/hr",pct:100,c:"#e8000d"}].map(r=>(
          <div key={r.l} style={{ marginBottom:16 }}>
            <div style={{ display:"flex", justifyContent:"space-between", marginBottom:6 }}>
              <span style={{ fontSize:13, color:"#64748b" }}>{r.l}</span>
              <span style={{ ...S_SC, fontWeight:700, fontSize:15, color:r.c }}>{r.rate}</span>
            </div>
            <div style={{ height:5, background:"#f1f5f9", borderRadius:3, overflow:"hidden" }}>
              <div style={{ width:`${r.pct}%`, height:"100%", background:r.c, borderRadius:3 }}/>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function SciSodium() {
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:32 }}>
      <div style={S_PROSE}>
        <p>Sweat contains sodium at 400–1,800mg per litre depending on the individual. Sodium stimulates thirst and aids intestinal glucose absorption via SGLT1 — the same mechanism that makes isotonic drinks more effective than plain water.</p>
        <br/><p>Hyponatraemia — dangerously low blood sodium — is a real risk in prolonged events where athletes drink large volumes of plain water without adequate sodium replacement.</p>
      </div>
      <SciCallout>Many athletes significantly under-consume sodium, especially in events over 3 hours. The longer the event, the more critical sodium strategy becomes.</SciCallout>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:10 }}>
        {[
          {num:"450–1000",unit:"MG/HR",label:"Typical endurance range",c:"#3b82f6"},
          {num:"1500+",unit:"MG/HR",label:"Extreme heat conditions",c:"#e8000d"},
          {num:"2%",unit:"BODY WEIGHT",label:"Dehydration threshold for measurable performance loss",c:"#f97316"},
          {num:"80%",unit:"REPLACEMENT TARGET",label:"Not 100% — risk of hyponatraemia",c:"#22c55e"},
        ].map((s,i)=>(
          <div key={i} style={{ background:"#fff", border:"1px solid rgba(0,0,0,0.07)", borderRadius:14, padding:"20px", display:"flex", gap:16, alignItems:"center" }}>
            <div style={{ ...S_SC, fontWeight:900, fontSize:28, background:`linear-gradient(135deg,${s.c},#3b82f6)`, WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", minWidth:80, lineHeight:1 }}>{s.num}</div>
            <div>
              <div style={{ fontSize:9, letterSpacing:3, color:s.c, fontWeight:700, ...S_SC }}>{s.unit}</div>
              <div style={{ fontSize:12, color:"#64748b", marginTop:3, lineHeight:1.5 }}>{s.label}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function SciHeat() {
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:32 }}>
      <div style={S_PROSE}>
        <p>The same rider with the same FTP needs a completely different fueling plan depending on environmental conditions. BonkProof adjusts fluid and sodium for temperature, and carbohydrate targets for altitude — automatically, in real time.</p>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>
        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          <div style={{ fontSize:10, letterSpacing:3, color:"#e8000d", fontWeight:700, ...S_SC, marginBottom:4 }}>HEAT — FLUID & SODIUM MULTIPLIERS</div>
          <SciTable
            heads={["Temperature","Fluid","Sodium","Condition"]}
            rows={HEAT_TABLE.map(r=>[r.temp,r.fluid,r.sodium,r.label])}
          />
        </div>
        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          <div style={{ fontSize:10, letterSpacing:3, color:"#3b82f6", fontWeight:700, ...S_SC, marginBottom:4 }}>ALTITUDE — CARB MULTIPLIERS</div>
          <SciTable
            heads={["Altitude","Carb Adj.","Condition"]}
            rows={ALT_TABLE.map(r=>[r.alt,r.carbs,r.label])}
          />
          <SciCallout color="#3b82f6">At altitude, reduced oxygen availability increases carbohydrate dependence — fat oxidation is impaired when oxygen delivery is limited.</SciCallout>
        </div>
      </div>
    </div>
  );
}

function SciCaffeine() {
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:32 }}>
      <div style={S_PROSE}>
        <p>Caffeine improves endurance performance through adenosine receptor antagonism reducing perceived effort, direct muscle effects improving contractile force, and fat oxidation sparing — extending glycogen availability.</p>
        <br/><p>The effective dose is 3–6mg per kg of body weight, taken 45–60 minutes before exercise.</p>
      </div>
      <SciCallout>Never try caffeine for the first time on race day. GI sensitivity varies significantly between individuals and high doses can cause anxiety, nausea and GI distress.</SciCallout>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:10 }}>
        <SciStatCard number="3–6" unit="MG / KG BW" label="Effective performance dose" color="#e8000d"/>
        <SciStatCard number="45–60" unit="MINUTES" label="Pre-exercise timing window" color="#3b82f6"/>
        <SciStatCard number="~100" unit="MG / GEL" label="Typical high-caffeine gel dose" color="#22c55e"/>
        <SciStatCard number="<400" unit="MG / DAY" label="Recommended daily upper limit" color="#3b82f6"/>
      </div>
    </div>
  );
}

function SciDIY() {
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:32 }}>
      <div style={S_PROSE}>
        <p>Every premium sports nutrition product — SiS Beta Fuel, Maurten Drink Mix, PF 90 — is built on the same two ingredients: maltodextrin and fructose. Making your own gives you the same dual-transporter performance at a fraction of the cost.</p>
        <br/><p>The 1:0.8 maltodextrin:fructose ratio maximises absorption when targeting intakes above 90g/hr.</p>
      </div>
      <SciCallout color="#22c55e">Always practise your homemade mix in training before race day. Start at lower concentrations if you're new to high-carb fueling.</SciCallout>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10 }}>
        {[
          { intake:"Up to 60g/hr", malto:"100%", fructo:"0%",  ratio:"Glucose only", c:"#22c55e", note:"Single transporter. No fructose needed." },
          { intake:"60–90g/hr",    malto:"67%",  fructo:"33%", ratio:"2:1",          c:"#3b82f6", note:"Dual transporter — standard protocol." },
          { intake:"90–120g/hr",   malto:"56%",  fructo:"44%", ratio:"1:0.8",        c:"#e8000d", note:"Maximum absorption — both transporters." },
        ].map(r=>(
          <div key={r.ratio} style={{ background:"#fff", border:"1px solid rgba(0,0,0,0.07)", borderRadius:14, padding:"20px", position:"relative", overflow:"hidden" }}>
            <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:r.c }}/>
            <div style={{ fontSize:10, letterSpacing:2, color:"#94a3b8", fontWeight:700, marginBottom:6, ...S_SC }}>{r.intake}</div>
            <div style={{ ...S_SC, fontWeight:900, fontSize:30, color:r.c, marginBottom:8 }}>{r.ratio}</div>
            <div style={{ height:5, background:"#f1f5f9", borderRadius:3, overflow:"hidden", marginBottom:10 }}>
              <div style={{ width:r.malto, height:"100%", background:"#e8000d", borderRadius:3, display:"inline-block" }}/>
              {r.fructo!=="0%" && <div style={{ width:r.fructo, height:"100%", background:"#3b82f6", display:"inline-block" }}/>}
            </div>
            <div style={{ fontSize:11, color:"#64748b", ...S_SC, fontWeight:700 }}>Malto {r.malto} · Fructose {r.fructo}</div>
            <div style={{ fontSize:12, color:"#94a3b8", marginTop:4 }}>{r.note}</div>
          </div>
        ))}
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:16 }}>
        <div>
          <div style={{ fontSize:10, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:12, ...S_SC }}>RECIPE PER 750ML BOTTLE</div>
          {[
            { target:"60g/hr · 2hr ride", malto:"33g", fructo:"27g", salt:"0.7g" },
            { target:"75g/hr · 3hr ride", malto:"42g", fructo:"33g", salt:"1.0g" },
            { target:"90g/hr · 4hr ride", malto:"50g", fructo:"40g", salt:"1.3g" },
            { target:"120g/hr · 4hr ride",malto:"67g", fructo:"53g", salt:"1.5g" },
          ].map((r,i)=>(
            <div key={i} style={{ background:"#fff", border:"1px solid rgba(0,0,0,0.07)", borderRadius:10, padding:"14px 16px", marginBottom:8 }}>
              <div style={{ fontSize:10, letterSpacing:2, color:"#3b82f6", fontWeight:700, marginBottom:8, ...S_SC }}>{r.target.toUpperCase()}</div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:6 }}>
                {[["MALTO",r.malto,"#e8000d"],["FRUCTOSE",r.fructo,"#3b82f6"],["SALT",r.salt,"#22c55e"]].map(([l,v,c])=>(
                  <div key={l} style={{ background:"#f8fafc", borderRadius:7, padding:"8px", textAlign:"center" }}>
                    <div style={{ ...S_SC, fontWeight:900, fontSize:18, color:c }}>{v}</div>
                    <div style={{ fontSize:7, letterSpacing:2, color:"#94a3b8", marginTop:2 }}>{l}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div>
          <div style={{ fontSize:10, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:12, ...S_SC }}>COST COMPARISON</div>
          <div style={{ background:"#fff", border:"1px solid rgba(0,0,0,0.07)", borderRadius:14, padding:"20px" }}>
            {[
              { label:"Homemade (1kg malto + 0.8kg fructo)", cost:"£7–8", per:"~18 servings", green:true },
              { label:"SiS Beta Fuel 80g sachet", cost:"~£3.50", per:"Per sachet", green:false },
              { label:"Maurten Drink Mix 320", cost:"~£4.00", per:"Per sachet", green:false },
              { label:"PF 90 sachet", cost:"~£3.50", per:"Per sachet", green:false },
            ].map((c,i)=>(
              <div key={i} style={{ display:"flex", justifyContent:"space-between", padding:"10px 0", borderBottom:i<3?"1px solid rgba(0,0,0,0.05)":"none", alignItems:"center" }}>
                <div style={{ fontSize:12, color:"#64748b", maxWidth:"55%", lineHeight:1.4 }}>{c.label}</div>
                <div style={{ textAlign:"right" }}>
                  <div style={{ ...S_SC, fontWeight:700, fontSize:18, color:c.green?"#22c55e":"#e8000d" }}>{c.cost}</div>
                  <div style={{ fontSize:10, color:"#94a3b8" }}>{c.per}</div>
                </div>
              </div>
            ))}
          </div>
          <SciCallout color="#22c55e">Search for <strong>"food grade maltodextrin DE17"</strong> — make sure it specifies food grade. Industrial maltodextrin should never be consumed.</SciCallout>
        </div>
      </div>
    </div>
  );
}

const SCI_CHAPTERS = [
  { id:"carbs",     icon:"⚡", label:"Carbohydrates", eyebrow:"01",  title:"Why carbs are the limiting factor",              sub:"At any intensity above Zone 2, carbohydrates become your primary fuel source.", Component:SciCarbs },
  { id:"transport", icon:"🔬", label:"Dual Transport", eyebrow:"02", title:"The transporter ceiling",                        sub:"The reason you can't just keep eating glucose — and why the ratio isn't marketing.", Component:SciTransport },
  { id:"gut",       icon:"🧬", label:"Gut Training",   eyebrow:"03", title:"Training the engine that fuels your engine",     sub:"Gut training is one of the most underutilised performance levers in endurance sport.", Component:SciGut },
  { id:"fluid",     icon:"💧", label:"Hydration",      eyebrow:"04", title:"Fluid: more than just thirst",                   sub:"Dehydration of even 2% of body weight measurably impairs performance.", Component:SciFluid },
  { id:"sodium",    icon:"🧂", label:"Sodium",         eyebrow:"05", title:"The forgotten electrolyte",                      sub:"The most critical electrolyte for endurance performance — and the one most athletes under-consume.", Component:SciSodium },
  { id:"heat",      icon:"🌡️", label:"Heat & Altitude",eyebrow:"06", title:"Heat & altitude adjustments",                    sub:"Same rider. Same FTP. Completely different fueling requirements.", Component:SciHeat },
  { id:"caffeine",  icon:"☕", label:"Caffeine",       eyebrow:"07", title:"The most evidence-backed legal performance aid", sub:"Caffeine is not optional for competitive endurance athletes.", Component:SciCaffeine },
  { id:"diy",       icon:"🧪", label:"DIY Mix",        eyebrow:"08", title:"Make your own fuel — for a fraction of the cost",sub:"Maltodextrin + fructose at 1:0.8. The same formula as every premium product.", Component:SciDIY },
];

function Science({ setPage, initialChapter }) {
  const [active, setActive] = useState(initialChapter || "carbs");
  const chapter = SCI_CHAPTERS.find(c=>c.id===active);
  const { Component } = chapter;
  const BG = "#e8eaf2";
  const DARK = "#0f172a";

  return (
    <div style={{ background:BG, minHeight:"100vh", fontFamily:"'Barlow',sans-serif" }}>
      <style>{`
        .sci-layout { display:grid; grid-template-columns:260px 1fr; min-height:calc(100vh - 54px); }
        .sci-sidebar { background:#fff; border-right:1px solid rgba(0,0,0,0.07); padding:28px 0; position:sticky; top:54px; height:calc(100vh - 54px); overflow-y:auto; }
        .sci-tab { background:transparent; border:none; border-radius:10px; font-family:"Barlow Condensed",sans-serif; font-size:14px; letter-spacing:1px; font-weight:700; padding:11px 16px; cursor:pointer; color:#94a3b8; transition:all .15s; display:flex; align-items:center; gap:10px; width:100%; text-align:left; }
        .sci-tab.on { color:#0f172a; background:#f1f5f9; }
        .sci-tab:hover:not(.on) { color:#475569; background:#f8fafc; }
        .sci-tab .sci-icon { font-size:17px; flex-shrink:0; }
        .sci-tab .sci-num { font-size:9px; letter-spacing:2px; color:#94a3b8; min-width:18px; }
        .sci-tab.on .sci-num { color:#e8000d; }
        .sci-main { overflow-y:auto; }
        @media(max-width:768px) {
          .sci-layout { grid-template-columns:1fr; }
          .sci-sidebar { position:relative; top:0; height:auto; border-right:none; border-bottom:1px solid rgba(0,0,0,0.07); padding:12px 0; }
          .sci-sidebar-inner { display:flex; flex-direction:row; flex-wrap:wrap; padding:0 16px; gap:4px; }
          .sci-tab { width:auto; padding:8px 12px; font-size:12px; }
          .sci-tab .sci-num { display:none; }
        }
      `}</style>

      <div className="sci-layout">

        {/* ── Sidebar ── */}
        <div className="sci-sidebar">
          <div style={{ fontSize:9, letterSpacing:4, color:"#94a3b8", fontWeight:700, padding:"0 24px 16px", fontFamily:"'Barlow Condensed',sans-serif" }}>SCIENCE LIBRARY</div>
          <div className="sci-sidebar-inner" style={{ display:"flex", flexDirection:"column", gap:2, padding:"0 12px" }}>
            {SCI_CHAPTERS.map(c=>(
              <button key={c.id} className={`sci-tab${active===c.id?" on":""}`} onClick={()=>setActive(c.id)}>
                <span className="sci-num">{c.eyebrow}</span>
                <span className="sci-icon">{c.icon}</span>
                <span>{c.label}</span>
              </button>
            ))}
          </div>
          {/* Sidebar CTA */}
          <div style={{ margin:"24px 16px 0", padding:"16px", background:"linear-gradient(145deg,#dde1ef,#e4e7f4)", borderRadius:12, border:"1px solid rgba(0,0,0,0.07)" }}>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:15, color:DARK, marginBottom:6, lineHeight:1.2 }}>Put it into practice</div>
            <div style={{ fontSize:12, color:"#64748b", marginBottom:12, lineHeight:1.5 }}>Calculate your exact plan using this science.</div>
            <button onClick={()=>setPage("calculator")} style={{ width:"100%", background:DARK, color:"#fff", border:"none", borderRadius:8, padding:"10px", fontFamily:"'Barlow',sans-serif", fontSize:13, fontWeight:600, cursor:"pointer" }}>
              Open calculator →
            </button>
          </div>
        </div>

        {/* ── Main content ── */}
        <div className="sci-main">

          {/* Chapter hero */}
          <div style={{ background:`linear-gradient(145deg,${DARK} 0%,#1e293b 100%)`, padding:"48px 56px", position:"relative", overflow:"hidden" }}>
            <div style={{ position:"absolute", inset:0, background:"radial-gradient(ellipse 60% 80% at 80% 50%, rgba(59,130,246,0.08) 0%, transparent 70%)", pointerEvents:"none" }}/>
            <div style={{ position:"relative", zIndex:2 }}>
              <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:16 }}>
                <div style={{ fontSize:9, letterSpacing:4, color:"#e8000d", fontWeight:700, fontFamily:"'Barlow Condensed',sans-serif" }}>{chapter.eyebrow}</div>
                <div style={{ width:32, height:1, background:"rgba(232,0,13,0.4)" }}/>
                <div style={{ fontSize:9, letterSpacing:3, color:"rgba(255,255,255,0.25)", fontFamily:"'Barlow Condensed',sans-serif" }}>SCIENCE LIBRARY</div>
              </div>
              <h1 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:"clamp(28px,4vw,52px)", lineHeight:0.95, letterSpacing:-0.5, color:"#fff", marginBottom:16, textTransform:"capitalize" }}>{chapter.title}</h1>
              <p style={{ fontSize:15, color:"rgba(255,255,255,0.45)", lineHeight:1.7, maxWidth:520 }}>{chapter.sub}</p>
            </div>
          </div>

          {/* Chapter body */}
          <div key={active} style={{ padding:"48px 56px", maxWidth:900 }}>
            <Component/>
          </div>

          {/* Chapter footer CTA */}
          <div style={{ margin:"0 56px 56px", background:DARK, borderRadius:16, padding:"36px 40px", display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:20 }}>
            <div>
              <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:22, color:"#fff", marginBottom:6 }}>Calculate your plan using this science.</div>
              <div style={{ fontSize:13, color:"rgba(255,255,255,0.4)" }}>Free. Peer-reviewed. No account needed.</div>
            </div>
            <button onClick={()=>setPage("calculator")} style={{ background:"linear-gradient(135deg,#e8000d,#3b82f6)", color:"#fff", border:"none", borderRadius:10, padding:"13px 28px", fontFamily:"'Barlow',sans-serif", fontSize:14, fontWeight:600, cursor:"pointer" }}>
              Start the calculator →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── SUPABASE CLIENT ───────────────────────────────────────────────────────────
const SUPABASE_URL = "https://crsfqsotohlegjzkvnpd.supabase.co";
const SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNyc2Zxc290b2hsZWdqemt2bnBkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkxMzI2NjMsImV4cCI6MjA5NDcwODY2M30.S8wuUYFC2jXpdeyMLdfQtJPrZEd2ABpfmh0eRXOh6zs";

// Lightweight Supabase client — no npm package needed, uses REST API directly
const supabase = (() => {
  const headers = {
    "Content-Type": "application/json",
    "apikey": SUPABASE_KEY,
    "Authorization": `Bearer ${SUPABASE_KEY}`,
  };

  const authHeaders = (token) => ({
    "Content-Type": "application/json",
    "apikey": SUPABASE_KEY,
    "Authorization": `Bearer ${token}`,
  });

  // Auth API calls
  const auth = {
    signUp: async ({ email, password }) => {
      const r = await fetch(`${SUPABASE_URL}/auth/v1/signup`, {
        method:"POST", headers,
        body: JSON.stringify({ email, password }),
      });
      return r.json();
    },
    signIn: async ({ email, password }) => {
      const r = await fetch(`${SUPABASE_URL}/auth/v1/token?grant_type=password`, {
        method:"POST", headers,
        body: JSON.stringify({ email, password }),
      });
      return r.json();
    },
    signOut: async (token) => {
      await fetch(`${SUPABASE_URL}/auth/v1/logout`, {
        method:"POST", headers: authHeaders(token),
      });
    },
    getUser: async (token) => {
      const r = await fetch(`${SUPABASE_URL}/auth/v1/user`, {
        headers: authHeaders(token),
      });
      return r.json();
    },
    refreshToken: async (refreshToken) => {
      const r = await fetch(`${SUPABASE_URL}/auth/v1/token?grant_type=refresh_token`, {
        method:"POST", headers,
        body: JSON.stringify({ refresh_token: refreshToken }),
      });
      return r.json();
    },
  };

  // Database API calls
  const from = (table) => ({
    select: async (cols="*", token, filters="") => {
      const r = await fetch(`${SUPABASE_URL}/rest/v1/${table}?select=${cols}${filters}`, {
        headers: authHeaders(token),
      });
      return r.json();
    },
    insert: async (data, token) => {
      const r = await fetch(`${SUPABASE_URL}/rest/v1/${table}`, {
        method:"POST",
        headers: { ...authHeaders(token), "Prefer":"return=representation" },
        body: JSON.stringify(data),
      });
      return r.json();
    },
    update: async (data, token, filters="") => {
      const r = await fetch(`${SUPABASE_URL}/rest/v1/${table}?${filters}`, {
        method:"PATCH",
        headers: { ...authHeaders(token), "Prefer":"return=representation" },
        body: JSON.stringify(data),
      });
      return r.json();
    },
    delete: async (token, filters="") => {
      const r = await fetch(`${SUPABASE_URL}/rest/v1/${table}?${filters}`, {
        method:"DELETE",
        headers: authHeaders(token),
      });
      return r.ok;
    },
  });

  return { auth, from };
})();

// Session helpers — store session in localStorage so it persists across page refreshes
const SESSION_KEY = "bonkproof_session";
const saveSession = (session) => {
  try { localStorage.setItem(SESSION_KEY, JSON.stringify(session)); } catch(e) {}
};
const loadSession = () => {
  try { return JSON.parse(localStorage.getItem(SESSION_KEY)); } catch(e) { return null; }
};
const clearSession = () => {
  try { localStorage.removeItem(SESSION_KEY); } catch(e) {}
};

// ── AUTH HOOK ─────────────────────────────────────────────────────────────────
function useAuth() {
  const [user,    setUser]    = useState(null);
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true); // true on mount while we check stored session
  const [error,   setError]   = useState("");

  // On mount — restore session from localStorage and validate it
  useEffect(() => {
    const restore = async () => {
      const stored = loadSession();
      if (!stored?.access_token) { setLoading(false); return; }

      // Extract user from stored session directly — most reliable across Supabase versions
      const storedUser = stored.user || stored.data?.user;

      if (storedUser?.id) {
        // We have a user in the session — validate token is still alive
        try {
          const check = await supabase.auth.getUser(stored.access_token);
          // getUser returns { id } or { user: { id } } depending on Supabase version
          const validUser = check?.id ? check : check?.user;

          if (validUser?.id) {
            const profile = await loadProfile(stored.access_token, validUser.id);
            setUser({ ...validUser, ...profile });
            setSession(stored);
          } else if (stored.refresh_token) {
            // Token expired — refresh
            const refreshed = await supabase.auth.refreshToken(stored.refresh_token);
            if (refreshed?.access_token) {
              saveSession(refreshed);
              setSession(refreshed);
              const rUser = refreshed.user || storedUser;
              const profile = await loadProfile(refreshed.access_token, rUser.id);
              setUser({ ...rUser, ...profile });
            } else {
              clearSession();
            }
          } else {
            // Token dead, no refresh — use stored user optimistically
            const profile = await loadProfile(stored.access_token, storedUser.id);
            setUser({ ...storedUser, ...profile });
            setSession(stored);
          }
        } catch(e) {
          // Network error — use stored session optimistically so app still works offline
          const profile = await loadProfile(stored.access_token, storedUser.id).catch(()=>({}));
          setUser({ ...storedUser, ...profile });
          setSession(stored);
        }
      } else if (stored.refresh_token) {
        const refreshed = await supabase.auth.refreshToken(stored.refresh_token);
        if (refreshed?.access_token) {
          saveSession(refreshed);
          setSession(refreshed);
          const rUser = refreshed.user;
          if (rUser?.id) {
            const profile = await loadProfile(refreshed.access_token, rUser.id);
            setUser({ ...rUser, ...profile });
          }
        } else {
          clearSession();
        }
      } else {
        clearSession();
      }
      setLoading(false);
    };
    restore();
  }, []);

  // Load athlete profile from profiles table
  const loadProfile = async (token, userId) => {
    try {
      const rows = await supabase.from("profiles").select("*", token, `&user_id=eq.${userId}`);
      return Array.isArray(rows) && rows.length > 0 ? rows[0] : {};
    } catch(e) { return {}; }
  };

  // Sign up — creates auth user + profile row + sends verification email
  const signup = async (email, password, profile) => {
    setLoading(true); setError("");
    try {
      const data = await supabase.auth.signUp({ email, password });

      // Handle error responses from Supabase
      if (data.error) {
        setError(data.error.message || data.error_description || "Sign up failed.");
        setLoading(false); return { ok:false };
      }
      if (data.msg) {
        setError(data.msg);
        setLoading(false); return { ok:false };
      }

      // Supabase v1 returns user directly, v2 returns { user, session }
      const authUser = data.user || data;
      const token    = data.access_token || data.session?.access_token;

      if (token) {
        // Auto-confirmed — create profile immediately and log in
        await createProfile(token, authUser.id, email, profile);
        saveSession(data.session || data);
        setSession(data.session || data);
        const profileData = await loadProfile(token, authUser.id);
        setUser({ ...authUser, ...profileData });
        setLoading(false);
        return { ok:true, needsVerification:false };
      } else if (authUser?.id || authUser?.email) {
        // Created but needs email verification — no token yet
        setLoading(false);
        try { localStorage.setItem("bp_pending_profile", JSON.stringify({ ...profile, email })); } catch(e) {}
        return { ok:true, needsVerification:true };
      } else {
        setError("Something went wrong. Please try again.");
        setLoading(false); return { ok:false };
      }
    } catch(e) {
      setError("Network error. Please try again.");
      setLoading(false); return { ok:false };
    }
  };

  // Create profile row in profiles table
  const createProfile = async (token, userId, email, profile) => {
    try {
      await supabase.from("profiles").insert({
        user_id:     userId,
        email:       email,
        name:        profile.name || "",
        weight_kg:   parseFloat(profile.weight) || 70,
        unit:        profile.unit || "kg",
        biological_sex: profile.sex || "male",
        gut_tier:    profile.gut || "trained",
        created_at:  new Date().toISOString(),
        last_active: new Date().toISOString(),
      }, token);
    } catch(e) { console.error("Profile creation failed:", e); }
  };

  // Login
  const login = async (email, password) => {
    setLoading(true); setError("");
    try {
      const data = await supabase.auth.signIn({ email, password });

      // Check for errors
      if (data.error || data.error_description) {
        const msg = (data.error_description || data.error?.message || data.error || "").toLowerCase();
        if (msg.includes("email not confirmed") || msg.includes("email_not_confirmed")) {
          setError("Please verify your email first — check your inbox for the confirmation link.");
        } else if (msg.includes("invalid") || msg.includes("credentials")) {
          setError("Incorrect email or password.");
        } else {
          setError("Login failed. Please try again.");
        }
        setLoading(false); return false;
      }

      const token = data.access_token || data.session?.access_token;
      if (!token) {
        setError("Login failed. Please try again.");
        setLoading(false); return false;
      }

      const authUser = data.user || data.data?.user || {};
      const sessionData = data.session || data;
      saveSession({ ...sessionData, user: authUser });
      setSession({ ...sessionData, user: authUser });

      // Load profile — create one if it doesn't exist
      let profile = await loadProfile(token, authUser.id);
      if (!profile?.user_id) {
        try {
          const pending = JSON.parse(localStorage.getItem("bp_pending_profile") || "null");
          if (pending) {
            await createProfile(token, authUser.id, authUser.email, pending);
            localStorage.removeItem("bp_pending_profile");
            profile = await loadProfile(token, authUser.id);
          }
        } catch(e) {}
      }

      setUser({ ...authUser, ...profile, email: authUser.email });
      setLoading(false);
      return true;
    } catch(e) {
      setError("Network error. Please try again.");
      setLoading(false); return false;
    }
  };

  // Logout
  const logout = async () => {
    try {
      if (session?.access_token) await supabase.auth.signOut(session.access_token);
    } catch(e) {}
    clearSession();
    setUser(null);
    setSession(null);
  };

  // Update profile
  const updateProfile = async (updates) => {
    if (!session?.access_token || !user?.user_id) return;
    try {
      await supabase.from("profiles").update({
        ...updates,
        last_active: new Date().toISOString(),
      }, session.access_token, `user_id=eq.${user.user_id}`);
      setUser(u => ({ ...u, ...updates }));
    } catch(e) { console.error("Profile update failed:", e); }
  };

  // Save a fueling plan
  const savePlan = async (plan) => {
    const token  = session?.access_token;
    const userId = user?.id || user?.sub || user?.user_id;
    if (!token || !userId) {
      console.error("savePlan: missing token or userId", { token:!!token, userId });
      return { ok:false, error:"Not logged in" };
    }
    try {
      const result = await supabase.from("plans").insert({
        user_id:         userId,
        created_at:      new Date().toISOString(),
        name:            plan.name,
        zone:            plan.zone,
        duration_hours:  plan.durationH,
        weight_kg:       plan.weightKg,
        gut_tier:        plan.gut,
        temp_celsius:    plan.temp,
        altitude_m:      plan.altitude,
        biological_sex:  plan.sex,
        luteal_phase:    plan.lutealPhase || false,
        carbs_total:     plan.totalC,
        carbs_per_hour:  plan.cph,
        fluid_total_ml:  plan.totalF,
        sodium_total_mg: plan.totalS,
        carb_ratio:      plan.ratio,
        brand_selected:  plan.brand,
        gut_feel_rating: null,
        notes:           "",
        ride_date:       plan.rideDate || null,
      }, token);

      // Supabase returns error object in body rather than throwing
      if (result?.code || result?.message || result?.error) {
        console.error("savePlan Supabase error:", result);
        return { ok:false, error: result.message || result.error || "Save failed" };
      }

      return { ok:true, plan: Array.isArray(result) ? result[0] : result };
    } catch(e) {
      console.error("savePlan exception:", e);
      return { ok:false, error:"Failed to save plan." };
    }
  };

  // Load saved plans
  const loadPlans = async () => {
    const token  = session?.access_token;
    const userId = user?.id || user?.sub || user?.user_id;
    if (!token || !userId) return [];
    try {
      const rows = await supabase.from("plans").select("*", token,
        `&user_id=eq.${userId}&order=created_at.desc`);
      if (!Array.isArray(rows)) {
        console.error("loadPlans unexpected response:", rows);
        return [];
      }
      return rows;
    } catch(e) {
      console.error("loadPlans error:", e);
      return [];
    }
  };

  // Update plan (gut feel rating + notes)
  const updatePlan = async (planId, updates) => {
    const token = session?.access_token;
    if (!token) { console.error("updatePlan: no token"); return; }
    try {
      const result = await supabase.from("plans").update(updates, token, `id=eq.${planId}`);
      if (result?.code || result?.message) {
        console.error("updatePlan Supabase error:", result);
      } else {
        console.log("updatePlan success:", planId, updates);
      }
    } catch(e) { console.error("Plan update failed:", e); }
  };

  // Delete plan
  const deletePlan = async (planId) => {
    if (!session?.access_token) return;
    try {
      await supabase.from("plans").delete(session.access_token, `id=eq.${planId}`);
    } catch(e) { console.error("Plan delete failed:", e); }
  };

  // Log analytics event (silent — never blocks UI)
  const logEvent = async (eventType, metadata = {}) => {
    if (!session?.access_token || !user?.id) return;
    try {
      await supabase.from("events").insert({
        user_id:    user.id,
        created_at: new Date().toISOString(),
        event_type: eventType,
        metadata:   JSON.stringify(metadata),
      }, session.access_token);
    } catch(e) {} // Silent fail — never block user actions for analytics
  };

  const clearError = () => setError("");

  return {
    user, session, loading, error,
    signup, login, logout, clearError,
    updateProfile, savePlan, loadPlans, updatePlan, deletePlan, logEvent,
    setUser,
  };
}

function AuthInput({ label, type, value, onChange, placeholder, extra }) {
  const [show, setShow] = useState(false);
  const isPass = type==="password";
  return (
    <div>
      <div style={{ fontSize:9, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:6 }}>{label}</div>
      <div style={{ position:"relative" }}>
        <input type={isPass&&show?"text":type} required value={value} onChange={onChange} placeholder={placeholder}
          style={{ width:"100%", background:"#fff", border:"1px solid #dde3ee", padding:"12px 14px", fontFamily:"'Barlow',sans-serif", fontSize:14, color:"#0f172a", outline:"none", paddingRight:isPass?44:14 }}
          onFocus={e=>e.target.style.borderColor="#e8000d"} onBlur={e=>e.target.style.borderColor="#dde3ee"}/>
        {isPass&&<button type="button" onClick={()=>setShow(s=>!s)} style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", color:"#94a3b8", fontSize:12, fontFamily:"'Barlow Condensed',sans-serif", letterSpacing:1, fontWeight:700 }}>{show?"HIDE":"SHOW"}</button>}
      </div>
      {extra}
    </div>
  );
}

function LoginPage({ onLogin, onSignup, onBack, error, loading, clearError }) {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const handle = async (e) => { e.preventDefault(); clearError(); await onLogin(email, pass); };
  return (
    <div style={{ minHeight:"100vh", background:"#f0f2f7", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ width:"100%", maxWidth:420 }}>
        <div style={{ textAlign:"center", marginBottom:32 }}>
          <BonkProofLogo size="md"/>
          <p style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#64748b", marginTop:12, fontWeight:300 }}>Sign in to access your fueling plans</p>
        </div>
        <div style={{ background:"#fff", border:"1px solid #dde3ee", padding:"32px 28px", boxShadow:"0 4px 24px rgba(0,0,0,.06)" }}>
          <div style={{ fontSize:9, letterSpacing:5, color:"#e8000d", fontWeight:700, marginBottom:20 }}>SIGN IN</div>
          {error&&<div style={{ background:"#fef2f2", border:"1px solid #fca5a5", padding:"10px 14px", marginBottom:16, fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#dc2626" }}>{error}</div>}
          <form onSubmit={handle} style={{ display:"flex", flexDirection:"column", gap:14 }}>
            <AuthInput label="EMAIL" type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@example.com"/>
            <AuthInput label="PASSWORD" type="password" value={pass} onChange={e=>setPass(e.target.value)} placeholder="••••••••"/>
            <button type="submit" disabled={loading} style={{ background:GRAD, border:"none", color:"#fff", fontFamily:"'Barlow Condensed',sans-serif", fontSize:13, letterSpacing:4, fontWeight:700, padding:"13px", cursor:loading?"not-allowed":"pointer", opacity:loading?.7:1, marginTop:4 }}>{loading?"SIGNING IN...":"SIGN IN"}</button>
          </form>
          <div style={{ textAlign:"center", marginTop:20, fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#64748b" }}>
            Don't have an account?{" "}<span onClick={onSignup} style={{ color:"#e8000d", cursor:"pointer", fontWeight:500 }}>Create one</span>
          </div>
          <div style={{ textAlign:"center", marginTop:12 }}>
            <span onClick={onBack} style={{ fontFamily:"'Barlow',sans-serif", fontSize:12, color:"#94a3b8", cursor:"pointer" }}>← Back to home</span>
          </div>
        </div>
      </div>
    </div>
  );
}

function SignupPage({ onBack, onSignup, onGoHome, error, loading, clearError }) {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [confirm, setConfirm] = useState("");
  const [passErr, setPassErr] = useState("");
  const [name, setName] = useState("");
  const [weight, setWeight] = useState("70");
  const [unit, setUnit] = useState("kg");
  const [sex, setSex] = useState("male");
  const [gut, setGut] = useState("trained");

  const validateStep1 = (e) => {
    e.preventDefault(); setPassErr("");
    if (pass.length<8) { setPassErr("Password must be at least 8 characters."); return; }
    if (pass!==confirm) { setPassErr("Passwords don't match."); return; }
    setStep(2);
  };
  const handleSubmit = async (e) => {
    e.preventDefault(); clearError();
    await onSignup(email, pass, { name, weight:parseFloat(weight)||70, unit, sex, gut });
  };

  return (
    <div style={{ minHeight:"100vh", background:"#f0f2f7", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ width:"100%", maxWidth:460 }}>
        <div style={{ textAlign:"center", marginBottom:32 }}>
          <BonkProofLogo size="md"/>
          <p style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#64748b", marginTop:12, fontWeight:300 }}>Create your BonkProof account</p>
        </div>
        <div style={{ background:"#fff", border:"1px solid #dde3ee", padding:"32px 28px", boxShadow:"0 4px 24px rgba(0,0,0,.06)" }}>
          {/* Step indicators */}
          <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:24 }}>
            {[1,2].map(i=>(
              <div key={i} style={{ display:"flex", alignItems:"center", gap:6 }}>
                <div style={{ width:24, height:24, borderRadius:"50%", background:step>=i?GRAD:"#f1f5f9", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:11, color:step>=i?"#fff":"#94a3b8" }}>{i}</div>
                <span style={{ fontSize:9, letterSpacing:3, color:step>=i?"#e8000d":"#94a3b8", fontWeight:700 }}>{i===1?"CREDENTIALS":"YOUR PROFILE"}</span>
                {i<2&&<div style={{ width:24, height:1, background:step>1?"#e8000d":"#dde3ee" }}/>}
              </div>
            ))}
          </div>

          {step===1&&(
            <form onSubmit={validateStep1} style={{ display:"flex", flexDirection:"column", gap:14 }}>
              <div style={{ fontSize:9, letterSpacing:5, color:"#e8000d", fontWeight:700, marginBottom:6 }}>CREATE ACCOUNT</div>
              <AuthInput label="EMAIL" type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@example.com"/>
              <AuthInput label="PASSWORD" type="password" value={pass} onChange={e=>setPass(e.target.value)} placeholder="Min. 8 characters" extra={
                pass.length>0&&<div>
                  <div style={{ height:3, background:"#f1f5f9", borderRadius:2, overflow:"hidden", marginTop:6 }}>
                    <div style={{ height:"100%", borderRadius:2, width:pass.length<6?"25%":pass.length<8?"50%":pass.length<12?"75%":"100%", background:pass.length<6?"#ef4444":pass.length<8?"#3b82f6":pass.length<12?"#eab308":"#22c55e" }}/>
                  </div>
                  <div style={{ fontSize:9, color:"#94a3b8", marginTop:4, letterSpacing:2 }}>{pass.length<6?"WEAK":pass.length<8?"FAIR":pass.length<12?"GOOD":"STRONG"}</div>
                </div>
              }/>
              <AuthInput label="CONFIRM PASSWORD" type="password" value={confirm} onChange={e=>setConfirm(e.target.value)} placeholder="Repeat password"/>
              {passErr&&<div style={{ color:"#dc2626", fontSize:12, fontFamily:"'Barlow',sans-serif" }}>{passErr}</div>}
              <button type="submit" style={{ background:GRAD, border:"none", color:"#fff", fontFamily:"'Barlow Condensed',sans-serif", fontSize:13, letterSpacing:4, fontWeight:700, padding:"13px", cursor:"pointer", marginTop:4 }}>CONTINUE →</button>
            </form>
          )}

          {step===2&&(
            <form onSubmit={handleSubmit} style={{ display:"flex", flexDirection:"column", gap:14 }}>
              <div style={{ fontSize:9, letterSpacing:5, color:"#e8000d", fontWeight:700, marginBottom:6 }}>YOUR ATHLETE PROFILE</div>
              <div style={{ fontFamily:"'Barlow',sans-serif", fontSize:12, color:"#64748b", lineHeight:1.6 }}>This pre-fills the calculator every time. You can change it anytime.</div>
              {error&&<div style={{ background:"#fef2f2", border:"1px solid #fca5a5", padding:"10px 14px", fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#dc2626" }}>{error}</div>}
              <AuthInput label="YOUR NAME" type="text" value={name} onChange={e=>setName(e.target.value)} placeholder="e.g. James"/>
              <div>
                <div style={{ fontSize:9, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:6 }}>BODY WEIGHT</div>
                <div style={{ display:"flex" }}>
                  <input type="number" value={weight} min={30} max={220} onChange={e=>setWeight(e.target.value)} onBlur={e=>{const v=parseFloat(e.target.value);setWeight(isNaN(v)?"70":String(Math.min(220,Math.max(30,v))));}} style={{ flex:1, background:"#fff", border:"1px solid #dde3ee", padding:"12px 14px", fontFamily:"'Barlow Condensed',sans-serif", fontWeight:800, fontSize:28, color:"#0f172a", outline:"none", borderRight:"none" }}/>
                  <div style={{ display:"flex", flexDirection:"column" }}>
                    {["kg","lbs"].map(u=><button key={u} type="button" onClick={()=>setUnit(u)} style={{ flex:1, background:unit===u?"#fef2f8":"#fff", border:"1px solid #dde3ee", borderBottom:u==="kg"?"none":"1px solid #dde3ee", color:unit===u?"#e8000d":"#94a3b8", fontFamily:"'Barlow Condensed',sans-serif", fontSize:11, letterSpacing:2, fontWeight:700, padding:"0 14px", cursor:"pointer" }}>{u.toUpperCase()}</button>)}
                  </div>
                </div>
              </div>
              <div>
                <div style={{ fontSize:9, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:6 }}>BIOLOGICAL SEX</div>
                <div style={{ display:"flex" }}>
                  {[["male","Male"],["female","Female"]].map(([k,l])=><button key={k} type="button" onClick={()=>setSex(k)} style={{ flex:1, background:sex===k?"#fef2f8":"#fff", border:"1px solid #dde3ee", borderRight:k==="male"?"none":"1px solid #dde3ee", color:sex===k?"#e8000d":"#94a3b8", fontFamily:"'Barlow Condensed',sans-serif", fontSize:13, letterSpacing:3, fontWeight:700, padding:"10px 0", cursor:"pointer" }}>{l.toUpperCase()}</button>)}
                </div>
              </div>
              <div>
                <div style={{ fontSize:9, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:6 }}>GUT TRAINING LEVEL</div>
                {[["beginner","Beginner","Untrained gut — typical starting point"],["trained","Trained","6+ months consistent high-carb fueling"],["elite","Elite Trained","Systematically trained — 100–120g/hr"]].map(([k,l,sub])=>(
                  <button key={k} type="button" onClick={()=>setGut(k)} style={{ width:"100%", display:"flex", justifyContent:"space-between", alignItems:"center", background:gut===k?"#fef2f8":"#fff", border:"1px solid #dde3ee", borderBottom:k!=="elite"?"none":"1px solid #dde3ee", padding:"10px 14px", cursor:"pointer" }}>
                    <div><div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:14, color:gut===k?"#e8000d":"#0f172a" }}>{l}</div><div style={{ fontSize:10, color:"#94a3b8", marginTop:2, fontFamily:"'Barlow',sans-serif" }}>{sub}</div></div>
                    {gut===k&&<div style={{ width:8, height:8, borderRadius:"50%", background:GRAD }}/>}
                  </button>
                ))}
              </div>
              <div style={{ display:"flex", gap:8, marginTop:4 }}>
                <button type="button" onClick={()=>setStep(1)} style={{ flex:1, background:"#fff", border:"1px solid #dde3ee", color:"#64748b", fontFamily:"'Barlow Condensed',sans-serif", fontSize:13, letterSpacing:3, fontWeight:700, padding:"12px", cursor:"pointer" }}>← BACK</button>
                <button type="submit" disabled={loading} style={{ flex:2, background:GRAD, border:"none", color:"#fff", fontFamily:"'Barlow Condensed',sans-serif", fontSize:13, letterSpacing:4, fontWeight:700, padding:"12px", cursor:loading?"not-allowed":"pointer", opacity:loading?.7:1 }}>{loading?"CREATING ACCOUNT...":"CREATE ACCOUNT"}</button>
              </div>
            </form>
          )}

          <div style={{ textAlign:"center", marginTop:20, fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#64748b" }}>
            Already have an account?{" "}<span onClick={onBack} style={{ color:"#e8000d", cursor:"pointer", fontWeight:500 }}>Sign in</span>
          </div>
          <div style={{ textAlign:"center", marginTop:12 }}>
            <span onClick={onGoHome} style={{ fontFamily:"'Barlow',sans-serif", fontSize:12, color:"#94a3b8", cursor:"pointer" }}>← Back to home</span>
          </div>
        </div>
        <div style={{ textAlign:"center", marginTop:16, fontSize:11, color:"#94a3b8", fontFamily:"'Barlow',sans-serif", lineHeight:1.6 }}>
          By creating an account you agree to our Terms of Service and Privacy Policy.
        </div>
      </div>
    </div>
  );
}

// ── PROFILE PAGE ─────────────────────────────────────────────────────────────
function ProfilePage({ user, setUser, updateProfile, setPage, onLogout }) {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(user.name||"");
  const [weight, setWeight] = useState(String(user.weight||70));
  const [unit, setUnit] = useState(user.unit||"kg");
  const [sex, setSex] = useState(user.sex||"male");
  const [gut, setGut] = useState(user.gut||"trained");
  const [saved, setSaved] = useState(false);

  const handleSave = async () => {
    const updates = {
      name,
      weight_kg: parseFloat(weight) || 70,
      unit,
      biological_sex: sex,
      gut_tier: gut,
    };
    await updateProfile(updates);
    setUser(u => ({ ...u, name, weight:parseFloat(weight)||70, unit, sex, gut }));
    setEditing(false); setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  const initials = (user.name||user.email||"?").split(" ").map(w=>w[0]).join("").toUpperCase().slice(0,2);

  return (
    <div style={{ background:"#f0f2f7", minHeight:"100vh", padding:"28px 20px" }}>
      <div style={{ maxWidth:680, margin:"0 auto" }}>
        <div style={{ background:"#0f172a", padding:"32px 28px", marginBottom:16, position:"relative", overflow:"hidden" }}>
          <div style={{ position:"absolute", width:300, height:300, borderRadius:"50%", background:"#e8000d", filter:"blur(80px)", opacity:.08, top:-100, right:-80 }}/>
          <div style={{ position:"relative", zIndex:2, display:"flex", alignItems:"center", gap:20, flexWrap:"wrap" }}>
            <div style={{ width:64, height:64, borderRadius:"50%", background:GRAD, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:24, color:"#fff", flexShrink:0 }}>{initials}</div>
            <div>
              <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:28, color:"#fff" }}>{user.name||"Athlete"}</div>
              <div style={{ fontSize:11, color:"rgba(255,255,255,.45)", letterSpacing:2, marginTop:3 }}>{user.email}</div>
              <div style={{ fontSize:9, color:"rgba(255,255,255,.25)", letterSpacing:2, marginTop:2 }}>MEMBER SINCE {new Date(user.joinedAt).toLocaleDateString("en-GB",{month:"long",year:"numeric"}).toUpperCase()}</div>
            </div>
          </div>
        </div>

        <div style={{ display:"flex", gap:10, marginBottom:16, flexWrap:"wrap" }}>
          {[["BODY WEIGHT",`${user.weight}${user.unit}`,user.unit==="kg"?`${Math.round(user.weight*2.205)} lbs`:`${Math.round(user.weight/2.205)} kg`],["SEX",user.sex==="male"?"Male":"Female","Substrate profile"],["GUT TIER",user.gut==="elite"?"Elite":user.gut==="trained"?"Trained":"Beginner",user.gut==="elite"?"100–120g/hr":user.gut==="trained"?"60–90g/hr":"Up to 60g/hr"]].map(([l,v,s])=>(
            <div key={l} style={{ background:"#fff", border:"1px solid #dde3ee", padding:"16px 18px", flex:1 }}>
              <div style={{ fontSize:8, letterSpacing:4, color:"#94a3b8", fontWeight:700, marginBottom:6 }}>{l}</div>
              <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:800, fontSize:26, background:GRAD, WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>{v}</div>
              <div style={{ fontSize:10, color:"#94a3b8", marginTop:3 }}>{s}</div>
            </div>
          ))}
        </div>

        {saved&&<div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", padding:"10px 16px", marginBottom:16, fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#15803d" }}>✓ Profile updated successfully</div>}

        <div style={{ background:"#fff", border:"1px solid #dde3ee", padding:"24px", marginBottom:16 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
            <div style={{ fontSize:9, letterSpacing:5, color:"#e8000d", fontWeight:700 }}>ATHLETE PROFILE</div>
            {!editing
              ? <Btn onClick={()=>setEditing(true)} variant="ghost" style={{ fontSize:10, padding:"6px 16px" }}>EDIT</Btn>
              : <div style={{ display:"flex", gap:8 }}>
                  <Btn onClick={()=>setEditing(false)} variant="ghost" style={{ fontSize:10, padding:"6px 14px" }}>CANCEL</Btn>
                  <Btn onClick={handleSave} style={{ fontSize:10, padding:"6px 16px" }}>SAVE CHANGES</Btn>
                </div>
            }
          </div>
          {editing?(
            <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
              <div><div style={{ fontSize:9, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:6 }}>NAME</div><input type="text" value={name} onChange={e=>setName(e.target.value)} style={{ width:"100%", background:"#fff", border:"1px solid #dde3ee", padding:"10px 12px", fontFamily:"'Barlow',sans-serif", fontSize:14, color:"#0f172a", outline:"none" }}/></div>
              <div><div style={{ fontSize:9, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:6 }}>BODY WEIGHT</div>
                <div style={{ display:"flex" }}>
                  <input type="number" value={weight} min={30} max={220} onChange={e=>setWeight(e.target.value)} onBlur={e=>{const v=parseFloat(e.target.value);setWeight(isNaN(v)?"70":String(Math.min(220,Math.max(30,v))));}} style={{ flex:1, background:"#fff", border:"1px solid #dde3ee", padding:"10px 12px", fontFamily:"'Barlow Condensed',sans-serif", fontWeight:800, fontSize:24, color:"#0f172a", outline:"none", borderRight:"none" }}/>
                  {["kg","lbs"].map(u=><button key={u} type="button" onClick={()=>setUnit(u)} style={{ background:unit===u?"#fef2f8":"#fff", border:"1px solid #dde3ee", borderBottom:u==="kg"?"none":"1px solid #dde3ee", color:unit===u?"#e8000d":"#94a3b8", fontFamily:"'Barlow Condensed',sans-serif", fontSize:11, letterSpacing:2, fontWeight:700, padding:"0 14px", cursor:"pointer", display:"block" }}>{u.toUpperCase()}</button>)}
                </div>
              </div>
              <div><div style={{ fontSize:9, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:6 }}>BIOLOGICAL SEX</div>
                <div style={{ display:"flex" }}>
                  {[["male","Male"],["female","Female"]].map(([k,l])=><button key={k} type="button" onClick={()=>setSex(k)} style={{ flex:1, background:sex===k?"#fef2f8":"#fff", border:"1px solid #dde3ee", borderRight:k==="male"?"none":"1px solid #dde3ee", color:sex===k?"#e8000d":"#94a3b8", fontFamily:"'Barlow Condensed',sans-serif", fontSize:13, letterSpacing:3, fontWeight:700, padding:"9px 0", cursor:"pointer" }}>{l.toUpperCase()}</button>)}
                </div>
              </div>
              <div><div style={{ fontSize:9, letterSpacing:3, color:"#94a3b8", fontWeight:700, marginBottom:6 }}>GUT TRAINING LEVEL</div>
                {[["beginner","Beginner","Up to 60g/hr"],["trained","Trained","60–90g/hr"],["elite","Elite Trained","100–120g/hr"]].map(([k,l,s])=>(
                  <button key={k} type="button" onClick={()=>setGut(k)} style={{ width:"100%", display:"flex", justifyContent:"space-between", alignItems:"center", background:gut===k?"#fef2f8":"#fff", border:"1px solid #dde3ee", borderBottom:k!=="elite"?"none":"1px solid #dde3ee", padding:"9px 14px", cursor:"pointer" }}>
                    <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:14, color:gut===k?"#e8000d":"#0f172a" }}>{l}</div>
                    <div style={{ fontSize:10, color:"#94a3b8" }}>{s}</div>
                  </button>
                ))}
              </div>
            </div>
          ):(
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              {[["Name",user.name||"—"],["Email",user.email],["Body weight",`${user.weight} ${user.unit}`],["Biological sex",user.sex==="male"?"Male":"Female"],["Gut training",user.gut==="elite"?"Elite Trained":user.gut==="trained"?"Trained":"Beginner"]].map(([l,v])=>(
                <div key={l} style={{ display:"flex", justifyContent:"space-between", padding:"10px 0", borderBottom:"1px solid #f8fafc" }}>
                  <span style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#94a3b8" }}>{l}</span>
                  <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:15 }}>{v}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:16 }}>
          {[["⚡","OPEN CALCULATOR","Pre-filled with your profile","calculator"],["📋","MY PLANS","View saved fueling plans","profiles"]].map(([icon,title,sub,p])=>(
            <button key={p} onClick={()=>setPage(p)} style={{ background:"#fff", border:"1px solid #dde3ee", padding:"16px", fontFamily:"'Barlow Condensed',sans-serif", fontSize:13, letterSpacing:3, fontWeight:700, cursor:"pointer", color:"#0f172a", textAlign:"left" }}>
              <div style={{ fontSize:20, marginBottom:8 }}>{icon}</div>
              <div>{title}</div>
              <div style={{ fontSize:9, color:"#94a3b8", letterSpacing:1, marginTop:3, fontFamily:"'Barlow',sans-serif", fontWeight:300 }}>{sub}</div>
            </button>
          ))}
        </div>
        <button onClick={onLogout} style={{ width:"100%", background:"#fff", border:"1px solid #dde3ee", padding:"12px", fontFamily:"'Barlow Condensed',sans-serif", fontSize:11, letterSpacing:4, fontWeight:700, cursor:"pointer", color:"#94a3b8" }}>SIGN OUT</button>
      </div>
    </div>
  );
}

// ── ROOT APP ─────────────────────────────────────────────────────────────────
export default function BonkProof() {
  const [page,        setPage]        = useState("landing");
  const [authView,    setAuthView]    = useState("login");
  const [sciChapter,  setSciChapter]  = useState(null);
  const [verifyEmail, setVerifyEmail] = useState("");

  const {
    user, session, loading, error,
    signup, login, logout, clearError,
    updateProfile, savePlan, loadPlans, updatePlan, deletePlan, logEvent,
    setUser,
  } = useAuth();

  useEffect(() => { window.scrollTo(0,0); }, [page]);

  const navigate = (p, chapter) => {
    if (["profiles","profile"].includes(p) && !user) { setPage("auth"); return; }
    setSciChapter(chapter || null);
    setPage(p);
  };

  // Show a loading spinner while we restore the session on first load
  if (loading) return (
    <div style={{ minHeight:"100vh", background:"#0f172a", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:20 }}>
      <style>{GLOBAL_CSS}</style>
      <BonkProofLogo size="md"/>
      <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:12, letterSpacing:4, color:"rgba(255,255,255,.4)" }}>LOADING...</div>
    </div>
  );

  if (page === "auth") {
    // Email verification holding screen
    if (authView === "verify") return (
      <div style={{ minHeight:"100vh", background:"#f0f2f7", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
        <style>{GLOBAL_CSS}</style>
        <div style={{ background:"#fff", border:"1px solid #dde3ee", padding:"48px 32px", maxWidth:420, width:"100%", textAlign:"center", boxShadow:"0 4px 24px rgba(0,0,0,.06)" }}>
          <div style={{ fontSize:48, marginBottom:16 }}>📧</div>
          <div style={{ fontSize:9, letterSpacing:5, color:"#e8000d", fontWeight:700, marginBottom:10 }}>CHECK YOUR INBOX</div>
          <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:26, marginBottom:14, lineHeight:1 }}>VERIFY YOUR EMAIL</div>
          <p style={{ fontFamily:"'Barlow',sans-serif", fontSize:14, color:"#64748b", lineHeight:1.75, fontWeight:300, marginBottom:8 }}>
            We've sent a verification link to:
          </p>
          <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:16, color:"#0f172a", background:"#f8fafc", border:"1px solid #dde3ee", padding:"10px 16px", marginBottom:24 }}>
            {verifyEmail}
          </div>
          <p style={{ fontFamily:"'Barlow',sans-serif", fontSize:13, color:"#94a3b8", lineHeight:1.7, marginBottom:24 }}>
            Click the link in the email to activate your account. Once verified, come back and sign in.
          </p>
          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            <Btn onClick={() => { setAuthView("login"); setPage("auth"); }} style={{ width:"100%", fontSize:13, padding:"13px" }}>
              SIGN IN AFTER VERIFYING
            </Btn>
            <button onClick={() => setPage("landing")} style={{ background:"none", border:"none", color:"#94a3b8", fontFamily:"'Barlow',sans-serif", fontSize:12, cursor:"pointer" }}>
              ← Back to home
            </button>
          </div>
        </div>
      </div>
    );

    if (authView === "signup") return (
      <div><style>{GLOBAL_CSS}</style>
        <SignupPage
          onBack={() => setAuthView("login")}
          onGoHome={() => setPage("landing")}
          onSignup={async (email, pass, profile) => {
            clearError();
            const result = await signup(email, pass, profile);
            if (result?.ok && result?.needsVerification) {
              setVerifyEmail(email);
              setAuthView("verify");
            } else if (result?.ok && !result?.needsVerification) {
              setPage("landing");
            }
            // if !result.ok, error is already set in useAuth and displays on the form
          }}
          error={error} loading={loading} clearError={clearError}
        />
      </div>
    );

    return (
      <div><style>{GLOBAL_CSS}</style>
        <LoginPage
          onLogin={async (email, pass) => {
            const ok = await login(email, pass);
            if (ok) setPage("landing");
          }}
          onSignup={() => setAuthView("signup")}
          onBack={() => setPage("landing")}
          error={error} loading={loading} clearError={clearError}
        />
      </div>
    );
  }

  if (page === "profile") {
    if (!user) { setPage("auth"); return null; }
    return (
      <div><style>{GLOBAL_CSS}</style>
        <Nav page={page} setPage={navigate} user={user} onAuthClick={() => setPage("auth")} onLogout={() => { logout(); setPage("landing"); }}/>
        <ProfilePage user={user} setUser={setUser} updateProfile={updateProfile} setPage={navigate} onLogout={() => { logout(); setPage("landing"); }}/>
      </div>
    );
  }

  return (
    <div>
      <style>{GLOBAL_CSS}</style>
      <Nav page={page} setPage={navigate} user={user} onAuthClick={() => { setAuthView("login"); setPage("auth"); }} onLogout={() => { logout(); setPage("landing"); }}/>
      {page === "landing"    && <Landing   setPage={navigate}/>}
      {page === "calculator" && <Calculator user={user} setPage={navigate} savePlan={savePlan} logEvent={logEvent}/>}
      {page === "profiles"   && <Profiles  setPage={navigate} user={user} loadPlans={loadPlans} updatePlan={updatePlan} deletePlan={deletePlan}/>}
      {page === "science"    && <Science   setPage={navigate} initialChapter={sciChapter} logEvent={logEvent}/>}
    </div>
  );
}